/**
 * @fileoverview gRPC-Web generated client stub for social.account
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.21.12
// source: services/account/account.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var services_common_common_pb = require('../../services/common/common_pb.js')
const proto = {};
proto.social = {};
proto.social.account = require('./account_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.social.account.AccountServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.social.account.AccountServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.SendOtpRequest,
 *   !proto.social.account.SendOtpResponse>}
 */
const methodDescriptor_AccountService_SendOtp = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/SendOtp',
  grpc.web.MethodType.UNARY,
  proto.social.account.SendOtpRequest,
  proto.social.account.SendOtpResponse,
  /**
   * @param {!proto.social.account.SendOtpRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.SendOtpResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.SendOtpRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.SendOtpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.SendOtpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.sendOtp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/SendOtp',
      request,
      metadata || {},
      methodDescriptor_AccountService_SendOtp,
      callback);
};


/**
 * @param {!proto.social.account.SendOtpRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.SendOtpResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.sendOtp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/SendOtp',
      request,
      metadata || {},
      methodDescriptor_AccountService_SendOtp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.VerifyOtpRequest,
 *   !proto.social.account.VerifyOtpResponse>}
 */
const methodDescriptor_AccountService_VerifyOtp = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/VerifyOtp',
  grpc.web.MethodType.UNARY,
  proto.social.account.VerifyOtpRequest,
  proto.social.account.VerifyOtpResponse,
  /**
   * @param {!proto.social.account.VerifyOtpRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.VerifyOtpResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.VerifyOtpRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.VerifyOtpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.VerifyOtpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.verifyOtp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/VerifyOtp',
      request,
      metadata || {},
      methodDescriptor_AccountService_VerifyOtp,
      callback);
};


/**
 * @param {!proto.social.account.VerifyOtpRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.VerifyOtpResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.verifyOtp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/VerifyOtp',
      request,
      metadata || {},
      methodDescriptor_AccountService_VerifyOtp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ChangePhoneRequest,
 *   !proto.social.account.OtpLimitResponse>}
 */
const methodDescriptor_AccountService_ChangePhone = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/ChangePhone',
  grpc.web.MethodType.UNARY,
  proto.social.account.ChangePhoneRequest,
  proto.social.account.OtpLimitResponse,
  /**
   * @param {!proto.social.account.ChangePhoneRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.OtpLimitResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.ChangePhoneRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.OtpLimitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.OtpLimitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.changePhone =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/ChangePhone',
      request,
      metadata || {},
      methodDescriptor_AccountService_ChangePhone,
      callback);
};


/**
 * @param {!proto.social.account.ChangePhoneRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.OtpLimitResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.changePhone =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/ChangePhone',
      request,
      metadata || {},
      methodDescriptor_AccountService_ChangePhone);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ChangeEmailRequest,
 *   !proto.social.account.OtpLimitResponse>}
 */
const methodDescriptor_AccountService_ChangeEmail = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/ChangeEmail',
  grpc.web.MethodType.UNARY,
  proto.social.account.ChangeEmailRequest,
  proto.social.account.OtpLimitResponse,
  /**
   * @param {!proto.social.account.ChangeEmailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.OtpLimitResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.ChangeEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.OtpLimitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.OtpLimitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.changeEmail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/ChangeEmail',
      request,
      metadata || {},
      methodDescriptor_AccountService_ChangeEmail,
      callback);
};


/**
 * @param {!proto.social.account.ChangeEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.OtpLimitResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.changeEmail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/ChangeEmail',
      request,
      metadata || {},
      methodDescriptor_AccountService_ChangeEmail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.account.VerifyOtpResponse>}
 */
const methodDescriptor_AccountService_Register = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Register',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  proto.social.account.VerifyOtpResponse,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.VerifyOtpResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.VerifyOtpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.VerifyOtpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.register =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Register',
      request,
      metadata || {},
      methodDescriptor_AccountService_Register,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.VerifyOtpResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.register =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Register',
      request,
      metadata || {},
      methodDescriptor_AccountService_Register);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_LogOut = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/LogOut',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.logOut =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/LogOut',
      request,
      metadata || {},
      methodDescriptor_AccountService_LogOut,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.logOut =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/LogOut',
      request,
      metadata || {},
      methodDescriptor_AccountService_LogOut);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.LoginRequest,
 *   !proto.social.account.VerifyOtpResponse>}
 */
const methodDescriptor_AccountService_Login = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Login',
  grpc.web.MethodType.UNARY,
  proto.social.account.LoginRequest,
  proto.social.account.VerifyOtpResponse,
  /**
   * @param {!proto.social.account.LoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.VerifyOtpResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.VerifyOtpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.VerifyOtpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.login =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Login',
      request,
      metadata || {},
      methodDescriptor_AccountService_Login,
      callback);
};


/**
 * @param {!proto.social.account.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.VerifyOtpResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.login =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Login',
      request,
      metadata || {},
      methodDescriptor_AccountService_Login);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ChangePasswordRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_ChangePassword = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/ChangePassword',
  grpc.web.MethodType.UNARY,
  proto.social.account.ChangePasswordRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ChangePasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ChangePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.changePassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/ChangePassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_ChangePassword,
      callback);
};


/**
 * @param {!proto.social.account.ChangePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.changePassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/ChangePassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_ChangePassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.DisablePasswordRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_DisablePassword = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/DisablePassword',
  grpc.web.MethodType.UNARY,
  proto.social.account.DisablePasswordRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.DisablePasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.DisablePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.disablePassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/DisablePassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_DisablePassword,
      callback);
};


/**
 * @param {!proto.social.account.DisablePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.disablePassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/DisablePassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_DisablePassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.account.Account>}
 */
const methodDescriptor_AccountService_GetProfile = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetProfile',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  proto.social.account.Account,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Account.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Account)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Account>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetProfile',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetProfile,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Account>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetProfile',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetProfile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AccountListIdRequest,
 *   !proto.social.account.AccountListResponse>}
 */
const methodDescriptor_AccountService_GetProfileList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetProfileList',
  grpc.web.MethodType.UNARY,
  proto.social.account.AccountListIdRequest,
  proto.social.account.AccountListResponse,
  /**
   * @param {!proto.social.account.AccountListIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.AccountListIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getProfileList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetProfileList',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetProfileList,
      callback);
};


/**
 * @param {!proto.social.account.AccountListIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getProfileList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetProfileList',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetProfileList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.account.Account>}
 */
const methodDescriptor_AccountService_UpdateProfile = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/UpdateProfile',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  proto.social.account.Account,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Account.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Account)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Account>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.updateProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/UpdateProfile',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateProfile,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Account>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.updateProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/UpdateProfile',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateProfile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.account.Notification>}
 */
const methodDescriptor_AccountService_GetNotificationSetting = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetNotificationSetting',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  proto.social.account.Notification,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Notification.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Notification)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Notification>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getNotificationSetting =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetNotificationSetting',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetNotificationSetting,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Notification>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getNotificationSetting =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetNotificationSetting',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetNotificationSetting);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Notification,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_UpdateNotificationSetting = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/UpdateNotificationSetting',
  grpc.web.MethodType.UNARY,
  proto.social.account.Notification,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Notification} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Notification} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.updateNotificationSetting =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/UpdateNotificationSetting',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateNotificationSetting,
      callback);
};


/**
 * @param {!proto.social.account.Notification} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.updateNotificationSetting =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/UpdateNotificationSetting',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateNotificationSetting);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.FindRequest,
 *   !proto.social.account.AccountListResponse>}
 */
const methodDescriptor_AccountService_Find = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Find',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.FindRequest,
  proto.social.account.AccountListResponse,
  /**
   * @param {!proto.social.common.FindRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.find =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Find',
      request,
      metadata || {},
      methodDescriptor_AccountService_Find,
      callback);
};


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.find =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Find',
      request,
      metadata || {},
      methodDescriptor_AccountService_Find);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.account.SendOtpResponse>}
 */
const methodDescriptor_AccountService_Delete = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Delete',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  proto.social.account.SendOtpResponse,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.SendOtpResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.SendOtpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.SendOtpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Delete',
      request,
      metadata || {},
      methodDescriptor_AccountService_Delete,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.SendOtpResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Delete',
      request,
      metadata || {},
      methodDescriptor_AccountService_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.VerifyOtpRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_DeleteVerify = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/DeleteVerify',
  grpc.web.MethodType.UNARY,
  proto.social.account.VerifyOtpRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.VerifyOtpRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.VerifyOtpRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.deleteVerify =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/DeleteVerify',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteVerify,
      callback);
};


/**
 * @param {!proto.social.account.VerifyOtpRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.deleteVerify =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/DeleteVerify',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteVerify);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.common.Pong>}
 */
const methodDescriptor_AccountService_Ping = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Ping',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  services_common_common_pb.Pong,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Pong.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Pong)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Pong>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.ping =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Ping',
      request,
      metadata || {},
      methodDescriptor_AccountService_Ping,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Pong>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.ping =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Ping',
      request,
      metadata || {},
      methodDescriptor_AccountService_Ping);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.account.FollowResponse>}
 */
const methodDescriptor_AccountService_Follow = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Follow',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  proto.social.account.FollowResponse,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.FollowResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.FollowResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.FollowResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.follow =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Follow',
      request,
      metadata || {},
      methodDescriptor_AccountService_Follow,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.FollowResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.follow =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Follow',
      request,
      metadata || {},
      methodDescriptor_AccountService_Follow);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_Unfollow = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Unfollow',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.unfollow =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Unfollow',
      request,
      metadata || {},
      methodDescriptor_AccountService_Unfollow,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.unfollow =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Unfollow',
      request,
      metadata || {},
      methodDescriptor_AccountService_Unfollow);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_RemoveFollower = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RemoveFollower',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.removeFollower =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RemoveFollower',
      request,
      metadata || {},
      methodDescriptor_AccountService_RemoveFollower,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.removeFollower =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RemoveFollower',
      request,
      metadata || {},
      methodDescriptor_AccountService_RemoveFollower);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_Block = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Block',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.block =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Block',
      request,
      metadata || {},
      methodDescriptor_AccountService_Block,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.block =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Block',
      request,
      metadata || {},
      methodDescriptor_AccountService_Block);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_Unblock = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Unblock',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.unblock =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Unblock',
      request,
      metadata || {},
      methodDescriptor_AccountService_Unblock,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.unblock =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Unblock',
      request,
      metadata || {},
      methodDescriptor_AccountService_Unblock);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.GetBlackListRequest,
 *   !proto.social.account.AccountListResponse>}
 */
const methodDescriptor_AccountService_GetBlockList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetBlockList',
  grpc.web.MethodType.UNARY,
  proto.social.account.GetBlackListRequest,
  proto.social.account.AccountListResponse,
  /**
   * @param {!proto.social.account.GetBlackListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.GetBlackListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getBlockList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetBlockList',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetBlockList,
      callback);
};


/**
 * @param {!proto.social.account.GetBlackListRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getBlockList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetBlockList',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetBlockList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AccountListRequest,
 *   !proto.social.account.AccountListResponse>}
 */
const methodDescriptor_AccountService_GetFollowers = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetFollowers',
  grpc.web.MethodType.UNARY,
  proto.social.account.AccountListRequest,
  proto.social.account.AccountListResponse,
  /**
   * @param {!proto.social.account.AccountListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.AccountListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getFollowers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetFollowers',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetFollowers,
      callback);
};


/**
 * @param {!proto.social.account.AccountListRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getFollowers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetFollowers',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetFollowers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AccountListRequest,
 *   !proto.social.account.GetFollowingResponse>}
 */
const methodDescriptor_AccountService_GetFollowing = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetFollowing',
  grpc.web.MethodType.UNARY,
  proto.social.account.AccountListRequest,
  proto.social.account.GetFollowingResponse,
  /**
   * @param {!proto.social.account.AccountListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.GetFollowingResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.AccountListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.GetFollowingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.GetFollowingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getFollowing =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetFollowing',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetFollowing,
      callback);
};


/**
 * @param {!proto.social.account.AccountListRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.GetFollowingResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getFollowing =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetFollowing',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetFollowing);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AccountListRequest,
 *   !proto.social.account.AccountListResponse>}
 */
const methodDescriptor_AccountService_GetFollowRequests = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetFollowRequests',
  grpc.web.MethodType.UNARY,
  proto.social.account.AccountListRequest,
  proto.social.account.AccountListResponse,
  /**
   * @param {!proto.social.account.AccountListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.AccountListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getFollowRequests =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetFollowRequests',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetFollowRequests,
      callback);
};


/**
 * @param {!proto.social.account.AccountListRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getFollowRequests =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetFollowRequests',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetFollowRequests);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.SearchAccountRequest,
 *   !proto.social.account.AccountListResponse>}
 */
const methodDescriptor_AccountService_SearchFollowing = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/SearchFollowing',
  grpc.web.MethodType.UNARY,
  proto.social.account.SearchAccountRequest,
  proto.social.account.AccountListResponse,
  /**
   * @param {!proto.social.account.SearchAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.SearchAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.searchFollowing =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/SearchFollowing',
      request,
      metadata || {},
      methodDescriptor_AccountService_SearchFollowing,
      callback);
};


/**
 * @param {!proto.social.account.SearchAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.searchFollowing =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/SearchFollowing',
      request,
      metadata || {},
      methodDescriptor_AccountService_SearchFollowing);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.SearchAccountRequest,
 *   !proto.social.account.AccountListResponse>}
 */
const methodDescriptor_AccountService_SearchFollowers = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/SearchFollowers',
  grpc.web.MethodType.UNARY,
  proto.social.account.SearchAccountRequest,
  proto.social.account.AccountListResponse,
  /**
   * @param {!proto.social.account.SearchAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.SearchAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.searchFollowers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/SearchFollowers',
      request,
      metadata || {},
      methodDescriptor_AccountService_SearchFollowers,
      callback);
};


/**
 * @param {!proto.social.account.SearchAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.searchFollowers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/SearchFollowers',
      request,
      metadata || {},
      methodDescriptor_AccountService_SearchFollowers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.RefreshTokenRequest,
 *   !proto.social.account.RefreshTokenResponse>}
 */
const methodDescriptor_AccountService_RefreshToken = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RefreshToken',
  grpc.web.MethodType.UNARY,
  proto.social.account.RefreshTokenRequest,
  proto.social.account.RefreshTokenResponse,
  /**
   * @param {!proto.social.account.RefreshTokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.RefreshTokenResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.RefreshTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.RefreshTokenResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.RefreshTokenResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.refreshToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RefreshToken',
      request,
      metadata || {},
      methodDescriptor_AccountService_RefreshToken,
      callback);
};


/**
 * @param {!proto.social.account.RefreshTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.RefreshTokenResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.refreshToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RefreshToken',
      request,
      metadata || {},
      methodDescriptor_AccountService_RefreshToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.common.UploadMediaResponse>}
 */
const methodDescriptor_AccountService_UploadProfilePhoto = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/UploadProfilePhoto',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  services_common_common_pb.UploadMediaResponse,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.UploadMediaResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.UploadMediaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.UploadMediaResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.uploadProfilePhoto =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/UploadProfilePhoto',
      request,
      metadata || {},
      methodDescriptor_AccountService_UploadProfilePhoto,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.UploadMediaResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.uploadProfilePhoto =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/UploadProfilePhoto',
      request,
      metadata || {},
      methodDescriptor_AccountService_UploadProfilePhoto);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.FollowersCategory,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AcceptFollowRequest = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AcceptFollowRequest',
  grpc.web.MethodType.UNARY,
  proto.social.account.FollowersCategory,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.FollowersCategory} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.FollowersCategory} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.acceptFollowRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AcceptFollowRequest',
      request,
      metadata || {},
      methodDescriptor_AccountService_AcceptFollowRequest,
      callback);
};


/**
 * @param {!proto.social.account.FollowersCategory} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.acceptFollowRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AcceptFollowRequest',
      request,
      metadata || {},
      methodDescriptor_AccountService_AcceptFollowRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_RejectFollowRequest = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RejectFollowRequest',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.rejectFollowRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RejectFollowRequest',
      request,
      metadata || {},
      methodDescriptor_AccountService_RejectFollowRequest,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.rejectFollowRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RejectFollowRequest',
      request,
      metadata || {},
      methodDescriptor_AccountService_RejectFollowRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.SetVisibilityRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_SetVisibility = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/SetVisibility',
  grpc.web.MethodType.UNARY,
  proto.social.account.SetVisibilityRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.SetVisibilityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.SetVisibilityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.setVisibility =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/SetVisibility',
      request,
      metadata || {},
      methodDescriptor_AccountService_SetVisibility,
      callback);
};


/**
 * @param {!proto.social.account.SetVisibilityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.setVisibility =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/SetVisibility',
      request,
      metadata || {},
      methodDescriptor_AccountService_SetVisibility);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Pagination,
 *   !proto.social.account.AccountListResponse>}
 */
const methodDescriptor_AccountService_GetPendingFollowRequests = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetPendingFollowRequests',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Pagination,
  proto.social.account.AccountListResponse,
  /**
   * @param {!proto.social.common.Pagination} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getPendingFollowRequests =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetPendingFollowRequests',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetPendingFollowRequests,
      callback);
};


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getPendingFollowRequests =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetPendingFollowRequests',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetPendingFollowRequests);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.common.BooleanValue>}
 */
const methodDescriptor_AccountService_isFollowing = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/isFollowing',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  services_common_common_pb.BooleanValue,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.BooleanValue.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.BooleanValue)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.BooleanValue>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.isFollowing =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/isFollowing',
      request,
      metadata || {},
      methodDescriptor_AccountService_isFollowing,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.BooleanValue>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.isFollowing =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/isFollowing',
      request,
      metadata || {},
      methodDescriptor_AccountService_isFollowing);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.common.BooleanValue>}
 */
const methodDescriptor_AccountService_isFollower = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/isFollower',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  services_common_common_pb.BooleanValue,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.BooleanValue.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.BooleanValue)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.BooleanValue>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.isFollower =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/isFollower',
      request,
      metadata || {},
      methodDescriptor_AccountService_isFollower,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.BooleanValue>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.isFollower =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/isFollower',
      request,
      metadata || {},
      methodDescriptor_AccountService_isFollower);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.CheckUsernameRequest,
 *   !proto.social.common.BooleanValue>}
 */
const methodDescriptor_AccountService_isUsernameAvailable = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/isUsernameAvailable',
  grpc.web.MethodType.UNARY,
  proto.social.account.CheckUsernameRequest,
  services_common_common_pb.BooleanValue,
  /**
   * @param {!proto.social.account.CheckUsernameRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.BooleanValue.deserializeBinary
);


/**
 * @param {!proto.social.account.CheckUsernameRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.BooleanValue)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.BooleanValue>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.isUsernameAvailable =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/isUsernameAvailable',
      request,
      metadata || {},
      methodDescriptor_AccountService_isUsernameAvailable,
      callback);
};


/**
 * @param {!proto.social.account.CheckUsernameRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.BooleanValue>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.isUsernameAvailable =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/isUsernameAvailable',
      request,
      metadata || {},
      methodDescriptor_AccountService_isUsernameAvailable);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.common.BooleanValue>}
 */
const methodDescriptor_AccountService_isVerified = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/isVerified',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  services_common_common_pb.BooleanValue,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.BooleanValue.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.BooleanValue)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.BooleanValue>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.isVerified =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/isVerified',
      request,
      metadata || {},
      methodDescriptor_AccountService_isVerified,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.BooleanValue>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.isVerified =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/isVerified',
      request,
      metadata || {},
      methodDescriptor_AccountService_isVerified);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_ToggleAccountType = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/ToggleAccountType',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.toggleAccountType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/ToggleAccountType',
      request,
      metadata || {},
      methodDescriptor_AccountService_ToggleAccountType,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.toggleAccountType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/ToggleAccountType',
      request,
      metadata || {},
      methodDescriptor_AccountService_ToggleAccountType);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.FCMToken,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_SetPushToken = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/SetPushToken',
  grpc.web.MethodType.UNARY,
  proto.social.account.FCMToken,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.FCMToken} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.FCMToken} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.setPushToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/SetPushToken',
      request,
      metadata || {},
      methodDescriptor_AccountService_SetPushToken,
      callback);
};


/**
 * @param {!proto.social.account.FCMToken} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.setPushToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/SetPushToken',
      request,
      metadata || {},
      methodDescriptor_AccountService_SetPushToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Pagination,
 *   !proto.social.account.AccountListResponse>}
 */
const methodDescriptor_AccountService_Suggestions = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Suggestions',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Pagination,
  proto.social.account.AccountListResponse,
  /**
   * @param {!proto.social.common.Pagination} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.suggestions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Suggestions',
      request,
      metadata || {},
      methodDescriptor_AccountService_Suggestions,
      callback);
};


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.suggestions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Suggestions',
      request,
      metadata || {},
      methodDescriptor_AccountService_Suggestions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_DisableAccount = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/DisableAccount',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.disableAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/DisableAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_DisableAccount,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.disableAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/DisableAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_DisableAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AccountListIdRequest,
 *   !proto.social.account.LastUpdateAccountListResponse>}
 */
const methodDescriptor_AccountService_GetLastUpdates = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetLastUpdates',
  grpc.web.MethodType.UNARY,
  proto.social.account.AccountListIdRequest,
  proto.social.account.LastUpdateAccountListResponse,
  /**
   * @param {!proto.social.account.AccountListIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.LastUpdateAccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.AccountListIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.LastUpdateAccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.LastUpdateAccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getLastUpdates =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetLastUpdates',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetLastUpdates,
      callback);
};


/**
 * @param {!proto.social.account.AccountListIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.LastUpdateAccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getLastUpdates =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetLastUpdates',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetLastUpdates);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.NewIdentifierRequest,
 *   !proto.social.account.OtpLimitResponse>}
 */
const methodDescriptor_AccountService_AddNewUserIdentifier = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AddNewUserIdentifier',
  grpc.web.MethodType.UNARY,
  proto.social.account.NewIdentifierRequest,
  proto.social.account.OtpLimitResponse,
  /**
   * @param {!proto.social.account.NewIdentifierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.OtpLimitResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.NewIdentifierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.OtpLimitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.OtpLimitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.addNewUserIdentifier =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AddNewUserIdentifier',
      request,
      metadata || {},
      methodDescriptor_AccountService_AddNewUserIdentifier,
      callback);
};


/**
 * @param {!proto.social.account.NewIdentifierRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.OtpLimitResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.addNewUserIdentifier =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AddNewUserIdentifier',
      request,
      metadata || {},
      methodDescriptor_AccountService_AddNewUserIdentifier);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.VerifyIdentifierRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_VerifyIdentifier = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/VerifyIdentifier',
  grpc.web.MethodType.UNARY,
  proto.social.account.VerifyIdentifierRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.VerifyIdentifierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.VerifyIdentifierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.verifyIdentifier =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/VerifyIdentifier',
      request,
      metadata || {},
      methodDescriptor_AccountService_VerifyIdentifier,
      callback);
};


/**
 * @param {!proto.social.account.VerifyIdentifierRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.verifyIdentifier =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/VerifyIdentifier',
      request,
      metadata || {},
      methodDescriptor_AccountService_VerifyIdentifier);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.TotpToggleCode,
 *   !proto.social.account.TotpUriResponse>}
 */
const methodDescriptor_AccountService_ActiveTotp = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/ActiveTotp',
  grpc.web.MethodType.UNARY,
  proto.social.account.TotpToggleCode,
  proto.social.account.TotpUriResponse,
  /**
   * @param {!proto.social.account.TotpToggleCode} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.TotpUriResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.TotpToggleCode} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.TotpUriResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.TotpUriResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.activeTotp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/ActiveTotp',
      request,
      metadata || {},
      methodDescriptor_AccountService_ActiveTotp,
      callback);
};


/**
 * @param {!proto.social.account.TotpToggleCode} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.TotpUriResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.activeTotp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/ActiveTotp',
      request,
      metadata || {},
      methodDescriptor_AccountService_ActiveTotp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.TotpCodeRequest,
 *   !proto.social.account.TotpRecoveryCodeResponse>}
 */
const methodDescriptor_AccountService_VerifyTotpFirstTime = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/VerifyTotpFirstTime',
  grpc.web.MethodType.UNARY,
  proto.social.account.TotpCodeRequest,
  proto.social.account.TotpRecoveryCodeResponse,
  /**
   * @param {!proto.social.account.TotpCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.TotpRecoveryCodeResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.TotpCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.TotpRecoveryCodeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.TotpRecoveryCodeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.verifyTotpFirstTime =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/VerifyTotpFirstTime',
      request,
      metadata || {},
      methodDescriptor_AccountService_VerifyTotpFirstTime,
      callback);
};


/**
 * @param {!proto.social.account.TotpCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.TotpRecoveryCodeResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.verifyTotpFirstTime =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/VerifyTotpFirstTime',
      request,
      metadata || {},
      methodDescriptor_AccountService_VerifyTotpFirstTime);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.TotpCodeRequest,
 *   !proto.social.account.VerifyOtpResponse>}
 */
const methodDescriptor_AccountService_VerifyTotp = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/VerifyTotp',
  grpc.web.MethodType.UNARY,
  proto.social.account.TotpCodeRequest,
  proto.social.account.VerifyOtpResponse,
  /**
   * @param {!proto.social.account.TotpCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.VerifyOtpResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.TotpCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.VerifyOtpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.VerifyOtpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.verifyTotp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/VerifyTotp',
      request,
      metadata || {},
      methodDescriptor_AccountService_VerifyTotp,
      callback);
};


/**
 * @param {!proto.social.account.TotpCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.VerifyOtpResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.verifyTotp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/VerifyTotp',
      request,
      metadata || {},
      methodDescriptor_AccountService_VerifyTotp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.TotpToggleCode,
 *   !proto.social.account.OtpLimitResponse>}
 */
const methodDescriptor_AccountService_DisableTotp = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/DisableTotp',
  grpc.web.MethodType.UNARY,
  proto.social.account.TotpToggleCode,
  proto.social.account.OtpLimitResponse,
  /**
   * @param {!proto.social.account.TotpToggleCode} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.OtpLimitResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.TotpToggleCode} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.OtpLimitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.OtpLimitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.disableTotp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/DisableTotp',
      request,
      metadata || {},
      methodDescriptor_AccountService_DisableTotp,
      callback);
};


/**
 * @param {!proto.social.account.TotpToggleCode} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.OtpLimitResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.disableTotp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/DisableTotp',
      request,
      metadata || {},
      methodDescriptor_AccountService_DisableTotp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.account.TotpRecoveryCodeResponse>}
 */
const methodDescriptor_AccountService_GenerateTotpRecoveryCode = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GenerateTotpRecoveryCode',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  proto.social.account.TotpRecoveryCodeResponse,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.TotpRecoveryCodeResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.TotpRecoveryCodeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.TotpRecoveryCodeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.generateTotpRecoveryCode =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GenerateTotpRecoveryCode',
      request,
      metadata || {},
      methodDescriptor_AccountService_GenerateTotpRecoveryCode,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.TotpRecoveryCodeResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.generateTotpRecoveryCode =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GenerateTotpRecoveryCode',
      request,
      metadata || {},
      methodDescriptor_AccountService_GenerateTotpRecoveryCode);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.TotpRecoveryCodeRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_RecoverTotp = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RecoverTotp',
  grpc.web.MethodType.UNARY,
  proto.social.account.TotpRecoveryCodeRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.TotpRecoveryCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.TotpRecoveryCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.recoverTotp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RecoverTotp',
      request,
      metadata || {},
      methodDescriptor_AccountService_RecoverTotp,
      callback);
};


/**
 * @param {!proto.social.account.TotpRecoveryCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.recoverTotp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RecoverTotp',
      request,
      metadata || {},
      methodDescriptor_AccountService_RecoverTotp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.TwoFactorAuthPasswordRequest,
 *   !proto.social.account.Recover2faResponse>}
 */
const methodDescriptor_AccountService_Active2faPassword = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Active2faPassword',
  grpc.web.MethodType.UNARY,
  proto.social.account.TwoFactorAuthPasswordRequest,
  proto.social.account.Recover2faResponse,
  /**
   * @param {!proto.social.account.TwoFactorAuthPasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Recover2faResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.TwoFactorAuthPasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Recover2faResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Recover2faResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.active2faPassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Active2faPassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_Active2faPassword,
      callback);
};


/**
 * @param {!proto.social.account.TwoFactorAuthPasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Recover2faResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.active2faPassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Active2faPassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_Active2faPassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.TwoFactorAuthPasswordRequest,
 *   !proto.social.account.Recover2faResponse>}
 */
const methodDescriptor_AccountService_DeActive2faPassword = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/DeActive2faPassword',
  grpc.web.MethodType.UNARY,
  proto.social.account.TwoFactorAuthPasswordRequest,
  proto.social.account.Recover2faResponse,
  /**
   * @param {!proto.social.account.TwoFactorAuthPasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Recover2faResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.TwoFactorAuthPasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Recover2faResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Recover2faResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.deActive2faPassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/DeActive2faPassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeActive2faPassword,
      callback);
};


/**
 * @param {!proto.social.account.TwoFactorAuthPasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Recover2faResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.deActive2faPassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/DeActive2faPassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeActive2faPassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ChangePasswordRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_Change2faPassword = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Change2faPassword',
  grpc.web.MethodType.UNARY,
  proto.social.account.ChangePasswordRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ChangePasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ChangePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.change2faPassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Change2faPassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_Change2faPassword,
      callback);
};


/**
 * @param {!proto.social.account.ChangePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.change2faPassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Change2faPassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_Change2faPassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Verify2faRequest,
 *   !proto.social.account.VerifyOtpResponse>}
 */
const methodDescriptor_AccountService_Verify2fa = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Verify2fa',
  grpc.web.MethodType.UNARY,
  proto.social.account.Verify2faRequest,
  proto.social.account.VerifyOtpResponse,
  /**
   * @param {!proto.social.account.Verify2faRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.VerifyOtpResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.Verify2faRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.VerifyOtpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.VerifyOtpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.verify2fa =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Verify2fa',
      request,
      metadata || {},
      methodDescriptor_AccountService_Verify2fa,
      callback);
};


/**
 * @param {!proto.social.account.Verify2faRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.VerifyOtpResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.verify2fa =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Verify2fa',
      request,
      metadata || {},
      methodDescriptor_AccountService_Verify2fa);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Recover2faRequest,
 *   !proto.social.account.Recover2faResponse>}
 */
const methodDescriptor_AccountService_Recover2fa = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Recover2fa',
  grpc.web.MethodType.UNARY,
  proto.social.account.Recover2faRequest,
  proto.social.account.Recover2faResponse,
  /**
   * @param {!proto.social.account.Recover2faRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Recover2faResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.Recover2faRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Recover2faResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Recover2faResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.recover2fa =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Recover2fa',
      request,
      metadata || {},
      methodDescriptor_AccountService_Recover2fa,
      callback);
};


/**
 * @param {!proto.social.account.Recover2faRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Recover2faResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.recover2fa =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Recover2fa',
      request,
      metadata || {},
      methodDescriptor_AccountService_Recover2fa);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.FCMToken,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_SetMqttToken = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/SetMqttToken',
  grpc.web.MethodType.UNARY,
  proto.social.account.FCMToken,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.FCMToken} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.FCMToken} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.setMqttToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/SetMqttToken',
      request,
      metadata || {},
      methodDescriptor_AccountService_SetMqttToken,
      callback);
};


/**
 * @param {!proto.social.account.FCMToken} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.setMqttToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/SetMqttToken',
      request,
      metadata || {},
      methodDescriptor_AccountService_SetMqttToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.GuestRequest,
 *   !proto.social.account.VerifyOtpResponse>}
 */
const methodDescriptor_AccountService_GuestLogin = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GuestLogin',
  grpc.web.MethodType.UNARY,
  proto.social.account.GuestRequest,
  proto.social.account.VerifyOtpResponse,
  /**
   * @param {!proto.social.account.GuestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.VerifyOtpResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.GuestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.VerifyOtpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.VerifyOtpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.guestLogin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GuestLogin',
      request,
      metadata || {},
      methodDescriptor_AccountService_GuestLogin,
      callback);
};


/**
 * @param {!proto.social.account.GuestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.VerifyOtpResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.guestLogin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GuestLogin',
      request,
      metadata || {},
      methodDescriptor_AccountService_GuestLogin);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Media,
 *   !proto.social.account.KycResponse>}
 */
const methodDescriptor_AccountService_Kyc = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Kyc',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Media,
  proto.social.account.KycResponse,
  /**
   * @param {!proto.social.common.Media} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.KycResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Media} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.KycResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.KycResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.kyc =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Kyc',
      request,
      metadata || {},
      methodDescriptor_AccountService_Kyc,
      callback);
};


/**
 * @param {!proto.social.common.Media} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.KycResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.kyc =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Kyc',
      request,
      metadata || {},
      methodDescriptor_AccountService_Kyc);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.GetAllPermissionsRequest,
 *   !proto.social.account.PermissionListResponse>}
 */
const methodDescriptor_AccountService_GetAllPermissions = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetAllPermissions',
  grpc.web.MethodType.UNARY,
  proto.social.account.GetAllPermissionsRequest,
  proto.social.account.PermissionListResponse,
  /**
   * @param {!proto.social.account.GetAllPermissionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.PermissionListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.GetAllPermissionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.PermissionListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.PermissionListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getAllPermissions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetAllPermissions',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetAllPermissions,
      callback);
};


/**
 * @param {!proto.social.account.GetAllPermissionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.PermissionListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getAllPermissions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetAllPermissions',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetAllPermissions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.RecoverPasswordRequest,
 *   !proto.social.account.RecoverPasswordResponse>}
 */
const methodDescriptor_AccountService_RecoverPasswordSendOtp = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RecoverPasswordSendOtp',
  grpc.web.MethodType.UNARY,
  proto.social.account.RecoverPasswordRequest,
  proto.social.account.RecoverPasswordResponse,
  /**
   * @param {!proto.social.account.RecoverPasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.RecoverPasswordResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.RecoverPasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.RecoverPasswordResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.RecoverPasswordResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.recoverPasswordSendOtp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RecoverPasswordSendOtp',
      request,
      metadata || {},
      methodDescriptor_AccountService_RecoverPasswordSendOtp,
      callback);
};


/**
 * @param {!proto.social.account.RecoverPasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.RecoverPasswordResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.recoverPasswordSendOtp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RecoverPasswordSendOtp',
      request,
      metadata || {},
      methodDescriptor_AccountService_RecoverPasswordSendOtp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.VerifyOtpRequest,
 *   !proto.social.account.VerifyOtpResponse>}
 */
const methodDescriptor_AccountService_RecoverPasswordVerifyOtp = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RecoverPasswordVerifyOtp',
  grpc.web.MethodType.UNARY,
  proto.social.account.VerifyOtpRequest,
  proto.social.account.VerifyOtpResponse,
  /**
   * @param {!proto.social.account.VerifyOtpRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.VerifyOtpResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.VerifyOtpRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.VerifyOtpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.VerifyOtpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.recoverPasswordVerifyOtp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RecoverPasswordVerifyOtp',
      request,
      metadata || {},
      methodDescriptor_AccountService_RecoverPasswordVerifyOtp,
      callback);
};


/**
 * @param {!proto.social.account.VerifyOtpRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.VerifyOtpResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.recoverPasswordVerifyOtp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RecoverPasswordVerifyOtp',
      request,
      metadata || {},
      methodDescriptor_AccountService_RecoverPasswordVerifyOtp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.RecoverPasswordVerifyRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_RecoverPassword = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RecoverPassword',
  grpc.web.MethodType.UNARY,
  proto.social.account.RecoverPasswordVerifyRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.RecoverPasswordVerifyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.RecoverPasswordVerifyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.recoverPassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RecoverPassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_RecoverPassword,
      callback);
};


/**
 * @param {!proto.social.account.RecoverPasswordVerifyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.recoverPassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RecoverPassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_RecoverPassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.TranslateRequest,
 *   !proto.social.account.TranslateResponse>}
 */
const methodDescriptor_AccountService_Translate = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Translate',
  grpc.web.MethodType.UNARY,
  proto.social.account.TranslateRequest,
  proto.social.account.TranslateResponse,
  /**
   * @param {!proto.social.account.TranslateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.TranslateResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.TranslateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.TranslateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.TranslateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.translate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Translate',
      request,
      metadata || {},
      methodDescriptor_AccountService_Translate,
      callback);
};


/**
 * @param {!proto.social.account.TranslateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.TranslateResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.translate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Translate',
      request,
      metadata || {},
      methodDescriptor_AccountService_Translate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.account.CustomFieldsListResponse>}
 */
const methodDescriptor_AccountService_GetCustomFields = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetCustomFields',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  proto.social.account.CustomFieldsListResponse,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.CustomFieldsListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.CustomFieldsListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.CustomFieldsListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getCustomFields =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetCustomFields',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetCustomFields,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.CustomFieldsListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getCustomFields =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetCustomFields',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetCustomFields);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.SyncContactsRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_SyncContacts = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/SyncContacts',
  grpc.web.MethodType.UNARY,
  proto.social.account.SyncContactsRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.SyncContactsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.SyncContactsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.syncContacts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/SyncContacts',
      request,
      metadata || {},
      methodDescriptor_AccountService_SyncContacts,
      callback);
};


/**
 * @param {!proto.social.account.SyncContactsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.syncContacts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/SyncContacts',
      request,
      metadata || {},
      methodDescriptor_AccountService_SyncContacts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.GetMyContactsRequest,
 *   !proto.social.account.AccountListResponse>}
 */
const methodDescriptor_AccountService_GetMyContacts = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetMyContacts',
  grpc.web.MethodType.UNARY,
  proto.social.account.GetMyContactsRequest,
  proto.social.account.AccountListResponse,
  /**
   * @param {!proto.social.account.GetMyContactsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.GetMyContactsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getMyContacts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetMyContacts',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetMyContacts,
      callback);
};


/**
 * @param {!proto.social.account.GetMyContactsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getMyContacts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetMyContacts',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetMyContacts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.account.PhoneListResponse>}
 */
const methodDescriptor_AccountService_GetMyContactsPhoneList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetMyContactsPhoneList',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  proto.social.account.PhoneListResponse,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.PhoneListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.PhoneListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.PhoneListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getMyContactsPhoneList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetMyContactsPhoneList',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetMyContactsPhoneList,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.PhoneListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getMyContactsPhoneList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetMyContactsPhoneList',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetMyContactsPhoneList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_UpsertContact = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/UpsertContact',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.upsertContact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/UpsertContact',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpsertContact,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.upsertContact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/UpsertContact',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpsertContact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AddBulkContactRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AddBulkContact = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AddBulkContact',
  grpc.web.MethodType.UNARY,
  proto.social.account.AddBulkContactRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.AddBulkContactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.AddBulkContactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.addBulkContact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AddBulkContact',
      request,
      metadata || {},
      methodDescriptor_AccountService_AddBulkContact,
      callback);
};


/**
 * @param {!proto.social.account.AddBulkContactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.addBulkContact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AddBulkContact',
      request,
      metadata || {},
      methodDescriptor_AccountService_AddBulkContact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_DeleteContacts = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/DeleteContacts',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.deleteContacts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/DeleteContacts',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteContacts,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.deleteContacts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/DeleteContacts',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteContacts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_DeleteContact = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/DeleteContact',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.deleteContact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/DeleteContact',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteContact,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.deleteContact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/DeleteContact',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteContact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ChatUserListResponse,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_UpsertContacts = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/UpsertContacts',
  grpc.web.MethodType.UNARY,
  proto.social.account.ChatUserListResponse,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ChatUserListResponse} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ChatUserListResponse} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.upsertContacts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/UpsertContacts',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpsertContacts,
      callback);
};


/**
 * @param {!proto.social.account.ChatUserListResponse} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.upsertContacts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/UpsertContacts',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpsertContacts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_EditContact = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/EditContact',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.editContact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/EditContact',
      request,
      metadata || {},
      methodDescriptor_AccountService_EditContact,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.editContact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/EditContact',
      request,
      metadata || {},
      methodDescriptor_AccountService_EditContact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.GetContactChangesRequest,
 *   !proto.social.account.AccountChangesResponse>}
 */
const methodDescriptor_AccountService_GetContactChanges = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetContactChanges',
  grpc.web.MethodType.UNARY,
  proto.social.account.GetContactChangesRequest,
  proto.social.account.AccountChangesResponse,
  /**
   * @param {!proto.social.account.GetContactChangesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountChangesResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.GetContactChangesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountChangesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountChangesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getContactChanges =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetContactChanges',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetContactChanges,
      callback);
};


/**
 * @param {!proto.social.account.GetContactChangesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountChangesResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getContactChanges =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetContactChanges',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetContactChanges);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.FollowersCategory,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AddToFollowersCategory = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AddToFollowersCategory',
  grpc.web.MethodType.UNARY,
  proto.social.account.FollowersCategory,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.FollowersCategory} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.FollowersCategory} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.addToFollowersCategory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AddToFollowersCategory',
      request,
      metadata || {},
      methodDescriptor_AccountService_AddToFollowersCategory,
      callback);
};


/**
 * @param {!proto.social.account.FollowersCategory} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.addToFollowersCategory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AddToFollowersCategory',
      request,
      metadata || {},
      methodDescriptor_AccountService_AddToFollowersCategory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.FollowersCategory,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_RemoveFromFollowersCategory = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RemoveFromFollowersCategory',
  grpc.web.MethodType.UNARY,
  proto.social.account.FollowersCategory,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.FollowersCategory} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.FollowersCategory} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.removeFromFollowersCategory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RemoveFromFollowersCategory',
      request,
      metadata || {},
      methodDescriptor_AccountService_RemoveFromFollowersCategory,
      callback);
};


/**
 * @param {!proto.social.account.FollowersCategory} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.removeFromFollowersCategory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RemoveFromFollowersCategory',
      request,
      metadata || {},
      methodDescriptor_AccountService_RemoveFromFollowersCategory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Category,
 *   !proto.social.common.Category>}
 */
const methodDescriptor_AccountService_CreateFollowersCategory = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/CreateFollowersCategory',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Category,
  services_common_common_pb.Category,
  /**
   * @param {!proto.social.common.Category} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Category.deserializeBinary
);


/**
 * @param {!proto.social.common.Category} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Category)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Category>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.createFollowersCategory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/CreateFollowersCategory',
      request,
      metadata || {},
      methodDescriptor_AccountService_CreateFollowersCategory,
      callback);
};


/**
 * @param {!proto.social.common.Category} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Category>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.createFollowersCategory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/CreateFollowersCategory',
      request,
      metadata || {},
      methodDescriptor_AccountService_CreateFollowersCategory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Category,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_DeleteFollowersCategory = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/DeleteFollowersCategory',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Category,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.common.Category} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.common.Category} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.deleteFollowersCategory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/DeleteFollowersCategory',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteFollowersCategory,
      callback);
};


/**
 * @param {!proto.social.common.Category} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.deleteFollowersCategory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/DeleteFollowersCategory',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteFollowersCategory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Pagination,
 *   !proto.social.account.FollowersCategoryList>}
 */
const methodDescriptor_AccountService_GetFollowersCategoryList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetFollowersCategoryList',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Pagination,
  proto.social.account.FollowersCategoryList,
  /**
   * @param {!proto.social.common.Pagination} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.FollowersCategoryList.deserializeBinary
);


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.FollowersCategoryList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.FollowersCategoryList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getFollowersCategoryList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetFollowersCategoryList',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetFollowersCategoryList,
      callback);
};


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.FollowersCategoryList>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getFollowersCategoryList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetFollowersCategoryList',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetFollowersCategoryList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.GetFollowersInCatRequest,
 *   !proto.social.account.AccountListResponse>}
 */
const methodDescriptor_AccountService_GetFollowersInCategory = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetFollowersInCategory',
  grpc.web.MethodType.UNARY,
  proto.social.account.GetFollowersInCatRequest,
  proto.social.account.AccountListResponse,
  /**
   * @param {!proto.social.account.GetFollowersInCatRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.GetFollowersInCatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getFollowersInCategory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetFollowersInCategory',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetFollowersInCategory,
      callback);
};


/**
 * @param {!proto.social.account.GetFollowersInCatRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getFollowersInCategory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetFollowersInCategory',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetFollowersInCategory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.account.FollowersCategoryList>}
 */
const methodDescriptor_AccountService_GetUserCategoryList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetUserCategoryList',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  proto.social.account.FollowersCategoryList,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.FollowersCategoryList.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.FollowersCategoryList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.FollowersCategoryList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getUserCategoryList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetUserCategoryList',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetUserCategoryList,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.FollowersCategoryList>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getUserCategoryList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetUserCategoryList',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetUserCategoryList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AccountAddress,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AddAddress = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AddAddress',
  grpc.web.MethodType.UNARY,
  proto.social.account.AccountAddress,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.AccountAddress} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.AccountAddress} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.addAddress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AddAddress',
      request,
      metadata || {},
      methodDescriptor_AccountService_AddAddress,
      callback);
};


/**
 * @param {!proto.social.account.AccountAddress} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.addAddress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AddAddress',
      request,
      metadata || {},
      methodDescriptor_AccountService_AddAddress);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AccountAddress,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_UpdateAddress = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/UpdateAddress',
  grpc.web.MethodType.UNARY,
  proto.social.account.AccountAddress,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.AccountAddress} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.AccountAddress} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.updateAddress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/UpdateAddress',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateAddress,
      callback);
};


/**
 * @param {!proto.social.account.AccountAddress} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.updateAddress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/UpdateAddress',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateAddress);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AccountAddress,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_DeleteAddress = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/DeleteAddress',
  grpc.web.MethodType.UNARY,
  proto.social.account.AccountAddress,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.AccountAddress} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.AccountAddress} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.deleteAddress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/DeleteAddress',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteAddress,
      callback);
};


/**
 * @param {!proto.social.account.AccountAddress} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.deleteAddress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/DeleteAddress',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteAddress);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Pagination,
 *   !proto.social.account.AddressListResponse>}
 */
const methodDescriptor_AccountService_GetAllAddresses = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetAllAddresses',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Pagination,
  proto.social.account.AddressListResponse,
  /**
   * @param {!proto.social.common.Pagination} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AddressListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AddressListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AddressListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getAllAddresses =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetAllAddresses',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetAllAddresses,
      callback);
};


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AddressListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getAllAddresses =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetAllAddresses',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetAllAddresses);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AccountAddress,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_SetDefaultAddress = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/SetDefaultAddress',
  grpc.web.MethodType.UNARY,
  proto.social.account.AccountAddress,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.AccountAddress} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.AccountAddress} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.setDefaultAddress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/SetDefaultAddress',
      request,
      metadata || {},
      methodDescriptor_AccountService_SetDefaultAddress,
      callback);
};


/**
 * @param {!proto.social.account.AccountAddress} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.setDefaultAddress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/SetDefaultAddress',
      request,
      metadata || {},
      methodDescriptor_AccountService_SetDefaultAddress);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.CreditCard,
 *   !proto.social.account.CreditCard>}
 */
const methodDescriptor_AccountService_GetCreditCard = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetCreditCard',
  grpc.web.MethodType.UNARY,
  proto.social.account.CreditCard,
  proto.social.account.CreditCard,
  /**
   * @param {!proto.social.account.CreditCard} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.CreditCard.deserializeBinary
);


/**
 * @param {!proto.social.account.CreditCard} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.CreditCard)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.CreditCard>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getCreditCard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetCreditCard',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetCreditCard,
      callback);
};


/**
 * @param {!proto.social.account.CreditCard} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.CreditCard>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getCreditCard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetCreditCard',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetCreditCard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.CreditCard,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AddCreditCard = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AddCreditCard',
  grpc.web.MethodType.UNARY,
  proto.social.account.CreditCard,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.CreditCard} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.CreditCard} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.addCreditCard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AddCreditCard',
      request,
      metadata || {},
      methodDescriptor_AccountService_AddCreditCard,
      callback);
};


/**
 * @param {!proto.social.account.CreditCard} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.addCreditCard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AddCreditCard',
      request,
      metadata || {},
      methodDescriptor_AccountService_AddCreditCard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.CreditCard,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_UpdateCreditCard = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/UpdateCreditCard',
  grpc.web.MethodType.UNARY,
  proto.social.account.CreditCard,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.CreditCard} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.CreditCard} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.updateCreditCard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/UpdateCreditCard',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateCreditCard,
      callback);
};


/**
 * @param {!proto.social.account.CreditCard} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.updateCreditCard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/UpdateCreditCard',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateCreditCard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.CreditCard,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_DeleteCreditCard = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/DeleteCreditCard',
  grpc.web.MethodType.UNARY,
  proto.social.account.CreditCard,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.CreditCard} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.CreditCard} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.deleteCreditCard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/DeleteCreditCard',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteCreditCard,
      callback);
};


/**
 * @param {!proto.social.account.CreditCard} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.deleteCreditCard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/DeleteCreditCard',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteCreditCard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Pagination,
 *   !proto.social.account.CreditCardListResponse>}
 */
const methodDescriptor_AccountService_GetAllCreditCards = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetAllCreditCards',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Pagination,
  proto.social.account.CreditCardListResponse,
  /**
   * @param {!proto.social.common.Pagination} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.CreditCardListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.CreditCardListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.CreditCardListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getAllCreditCards =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetAllCreditCards',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetAllCreditCards,
      callback);
};


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.CreditCardListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getAllCreditCards =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetAllCreditCards',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetAllCreditCards);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.CartPublishStatusRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminAccountApproveCreditCard = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAccountApproveCreditCard',
  grpc.web.MethodType.UNARY,
  proto.social.account.CartPublishStatusRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.CartPublishStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.CartPublishStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAccountApproveCreditCard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountApproveCreditCard',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountApproveCreditCard,
      callback);
};


/**
 * @param {!proto.social.account.CartPublishStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAccountApproveCreditCard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountApproveCreditCard',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountApproveCreditCard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.CartPublishStatusRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminAccountRejectCreditCard = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAccountRejectCreditCard',
  grpc.web.MethodType.UNARY,
  proto.social.account.CartPublishStatusRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.CartPublishStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.CartPublishStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAccountRejectCreditCard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountRejectCreditCard',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountRejectCreditCard,
      callback);
};


/**
 * @param {!proto.social.account.CartPublishStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAccountRejectCreditCard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountRejectCreditCard',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountRejectCreditCard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Pagination,
 *   !proto.social.account.SessionListResponse>}
 */
const methodDescriptor_AccountService_GetSessions = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetSessions',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Pagination,
  proto.social.account.SessionListResponse,
  /**
   * @param {!proto.social.common.Pagination} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.SessionListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.SessionListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.SessionListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getSessions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetSessions',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetSessions,
      callback);
};


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.SessionListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getSessions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetSessions',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetSessions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Session,
 *   !proto.social.common.BooleanValue>}
 */
const methodDescriptor_AccountService_IsSessionActive = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/IsSessionActive',
  grpc.web.MethodType.UNARY,
  proto.social.account.Session,
  services_common_common_pb.BooleanValue,
  /**
   * @param {!proto.social.account.Session} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.BooleanValue.deserializeBinary
);


/**
 * @param {!proto.social.account.Session} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.BooleanValue)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.BooleanValue>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.isSessionActive =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/IsSessionActive',
      request,
      metadata || {},
      methodDescriptor_AccountService_IsSessionActive,
      callback);
};


/**
 * @param {!proto.social.account.Session} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.BooleanValue>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.isSessionActive =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/IsSessionActive',
      request,
      metadata || {},
      methodDescriptor_AccountService_IsSessionActive);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Session,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_DeleteSession = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/DeleteSession',
  grpc.web.MethodType.UNARY,
  proto.social.account.Session,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Session} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Session} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.deleteSession =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/DeleteSession',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteSession,
      callback);
};


/**
 * @param {!proto.social.account.Session} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.deleteSession =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/DeleteSession',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteSession);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_DeleteAllSessions = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/DeleteAllSessions',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.deleteAllSessions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/DeleteAllSessions',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteAllSessions,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.deleteAllSessions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/DeleteAllSessions',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteAllSessions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Meeting,
 *   !proto.social.account.Meeting>}
 */
const methodDescriptor_AccountService_CreateMeeting = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/CreateMeeting',
  grpc.web.MethodType.UNARY,
  proto.social.account.Meeting,
  proto.social.account.Meeting,
  /**
   * @param {!proto.social.account.Meeting} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Meeting.deserializeBinary
);


/**
 * @param {!proto.social.account.Meeting} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Meeting)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Meeting>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.createMeeting =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/CreateMeeting',
      request,
      metadata || {},
      methodDescriptor_AccountService_CreateMeeting,
      callback);
};


/**
 * @param {!proto.social.account.Meeting} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Meeting>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.createMeeting =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/CreateMeeting',
      request,
      metadata || {},
      methodDescriptor_AccountService_CreateMeeting);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Meeting,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_UpdateMeeting = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/UpdateMeeting',
  grpc.web.MethodType.UNARY,
  proto.social.account.Meeting,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Meeting} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Meeting} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.updateMeeting =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/UpdateMeeting',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateMeeting,
      callback);
};


/**
 * @param {!proto.social.account.Meeting} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.updateMeeting =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/UpdateMeeting',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateMeeting);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Meeting,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_DeleteMeeting = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/DeleteMeeting',
  grpc.web.MethodType.UNARY,
  proto.social.account.Meeting,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Meeting} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Meeting} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.deleteMeeting =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/DeleteMeeting',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteMeeting,
      callback);
};


/**
 * @param {!proto.social.account.Meeting} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.deleteMeeting =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/DeleteMeeting',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteMeeting);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Meeting,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_StartMeeting = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/StartMeeting',
  grpc.web.MethodType.UNARY,
  proto.social.account.Meeting,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Meeting} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Meeting} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.startMeeting =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/StartMeeting',
      request,
      metadata || {},
      methodDescriptor_AccountService_StartMeeting,
      callback);
};


/**
 * @param {!proto.social.account.Meeting} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.startMeeting =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/StartMeeting',
      request,
      metadata || {},
      methodDescriptor_AccountService_StartMeeting);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Meeting,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_EndMeeting = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/EndMeeting',
  grpc.web.MethodType.UNARY,
  proto.social.account.Meeting,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Meeting} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Meeting} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.endMeeting =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/EndMeeting',
      request,
      metadata || {},
      methodDescriptor_AccountService_EndMeeting,
      callback);
};


/**
 * @param {!proto.social.account.Meeting} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.endMeeting =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/EndMeeting',
      request,
      metadata || {},
      methodDescriptor_AccountService_EndMeeting);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.GetMeetingListRequest,
 *   !proto.social.account.MeetingListResponse>}
 */
const methodDescriptor_AccountService_GetMeetingList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetMeetingList',
  grpc.web.MethodType.UNARY,
  proto.social.account.GetMeetingListRequest,
  proto.social.account.MeetingListResponse,
  /**
   * @param {!proto.social.account.GetMeetingListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.MeetingListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.GetMeetingListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.MeetingListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.MeetingListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getMeetingList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetMeetingList',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetMeetingList,
      callback);
};


/**
 * @param {!proto.social.account.GetMeetingListRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.MeetingListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getMeetingList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetMeetingList',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetMeetingList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Meeting,
 *   !proto.social.account.TransScriptResponse>}
 */
const methodDescriptor_AccountService_GetTransScript = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetTransScript',
  grpc.web.MethodType.UNARY,
  proto.social.account.Meeting,
  proto.social.account.TransScriptResponse,
  /**
   * @param {!proto.social.account.Meeting} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.TransScriptResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.Meeting} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.TransScriptResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.TransScriptResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getTransScript =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetTransScript',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetTransScript,
      callback);
};


/**
 * @param {!proto.social.account.Meeting} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.TransScriptResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getTransScript =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetTransScript',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetTransScript);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Meeting,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_DeleteMeetingAndRecording = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/DeleteMeetingAndRecording',
  grpc.web.MethodType.UNARY,
  proto.social.account.Meeting,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Meeting} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Meeting} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.deleteMeetingAndRecording =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/DeleteMeetingAndRecording',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteMeetingAndRecording,
      callback);
};


/**
 * @param {!proto.social.account.Meeting} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.deleteMeetingAndRecording =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/DeleteMeetingAndRecording',
      request,
      metadata || {},
      methodDescriptor_AccountService_DeleteMeetingAndRecording);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.SendBulkInvitesViaSmsRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_SendBulkInvitesViaSms = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/SendBulkInvitesViaSms',
  grpc.web.MethodType.UNARY,
  proto.social.account.SendBulkInvitesViaSmsRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.SendBulkInvitesViaSmsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.SendBulkInvitesViaSmsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.sendBulkInvitesViaSms =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/SendBulkInvitesViaSms',
      request,
      metadata || {},
      methodDescriptor_AccountService_SendBulkInvitesViaSms,
      callback);
};


/**
 * @param {!proto.social.account.SendBulkInvitesViaSmsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.sendBulkInvitesViaSms =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/SendBulkInvitesViaSms',
      request,
      metadata || {},
      methodDescriptor_AccountService_SendBulkInvitesViaSms);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ClientVersion,
 *   !proto.social.account.ClientVersionListResponse>}
 */
const methodDescriptor_AccountService_GetClientVersionList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetClientVersionList',
  grpc.web.MethodType.UNARY,
  proto.social.account.ClientVersion,
  proto.social.account.ClientVersionListResponse,
  /**
   * @param {!proto.social.account.ClientVersion} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ClientVersionListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.ClientVersion} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ClientVersionListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ClientVersionListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getClientVersionList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetClientVersionList',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetClientVersionList,
      callback);
};


/**
 * @param {!proto.social.account.ClientVersion} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ClientVersionListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getClientVersionList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetClientVersionList',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetClientVersionList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ReportAbuse,
 *   !proto.social.account.ReportAbuse>}
 */
const methodDescriptor_AccountService_CreateReportAbuse = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/CreateReportAbuse',
  grpc.web.MethodType.UNARY,
  proto.social.account.ReportAbuse,
  proto.social.account.ReportAbuse,
  /**
   * @param {!proto.social.account.ReportAbuse} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ReportAbuse.deserializeBinary
);


/**
 * @param {!proto.social.account.ReportAbuse} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ReportAbuse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ReportAbuse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.createReportAbuse =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/CreateReportAbuse',
      request,
      metadata || {},
      methodDescriptor_AccountService_CreateReportAbuse,
      callback);
};


/**
 * @param {!proto.social.account.ReportAbuse} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ReportAbuse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.createReportAbuse =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/CreateReportAbuse',
      request,
      metadata || {},
      methodDescriptor_AccountService_CreateReportAbuse);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ToggleAccount,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminAccountDisable = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAccountDisable',
  grpc.web.MethodType.UNARY,
  proto.social.account.ToggleAccount,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ToggleAccount} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ToggleAccount} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAccountDisable =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountDisable',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountDisable,
      callback);
};


/**
 * @param {!proto.social.account.ToggleAccount} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAccountDisable =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountDisable',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountDisable);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ToggleAccount,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminAccountDelete = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAccountDelete',
  grpc.web.MethodType.UNARY,
  proto.social.account.ToggleAccount,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ToggleAccount} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ToggleAccount} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAccountDelete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountDelete',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountDelete,
      callback);
};


/**
 * @param {!proto.social.account.ToggleAccount} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAccountDelete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountDelete',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountDelete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ToggleAccount,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminAccountVerify = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAccountVerify',
  grpc.web.MethodType.UNARY,
  proto.social.account.ToggleAccount,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ToggleAccount} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ToggleAccount} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAccountVerify =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountVerify',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountVerify,
      callback);
};


/**
 * @param {!proto.social.account.ToggleAccount} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAccountVerify =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountVerify',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountVerify);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ToggleAccount,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminAccountBan = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAccountBan',
  grpc.web.MethodType.UNARY,
  proto.social.account.ToggleAccount,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ToggleAccount} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ToggleAccount} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAccountBan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountBan',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountBan,
      callback);
};


/**
 * @param {!proto.social.account.ToggleAccount} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAccountBan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountBan',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountBan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.account.Account>}
 */
const methodDescriptor_AccountService_AdminAccountUpdate = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAccountUpdate',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  proto.social.account.Account,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Account.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Account)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Account>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAccountUpdate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountUpdate',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountUpdate,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Account>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAccountUpdate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountUpdate',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountUpdate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Pagination,
 *   !proto.social.account.AccountListResponse>}
 */
const methodDescriptor_AccountService_AdminAccountAll = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAccountAll',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Pagination,
  proto.social.account.AccountListResponse,
  /**
   * @param {!proto.social.common.Pagination} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAccountAll =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountAll',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountAll,
      callback);
};


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAccountAll =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountAll',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountAll);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.FilterAccountsByRequest,
 *   !proto.social.account.AccountListResponse>}
 */
const methodDescriptor_AccountService_AdminFilterAccountsBy = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminFilterAccountsBy',
  grpc.web.MethodType.UNARY,
  proto.social.account.FilterAccountsByRequest,
  proto.social.account.AccountListResponse,
  /**
   * @param {!proto.social.account.FilterAccountsByRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.FilterAccountsByRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminFilterAccountsBy =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminFilterAccountsBy',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminFilterAccountsBy,
      callback);
};


/**
 * @param {!proto.social.account.FilterAccountsByRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminFilterAccountsBy =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminFilterAccountsBy',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminFilterAccountsBy);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AccountActionRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminAccountAction = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAccountAction',
  grpc.web.MethodType.UNARY,
  proto.social.account.AccountActionRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.AccountActionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.AccountActionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAccountAction =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountAction',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountAction,
      callback);
};


/**
 * @param {!proto.social.account.AccountActionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAccountAction =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountAction',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountAction);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.account.Account>}
 */
const methodDescriptor_AccountService_AdminGetAccount = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetAccount',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  proto.social.account.Account,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Account.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Account)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Account>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetAccount,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Account>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.RestoreAccount,
 *   !proto.social.account.RestoreAccountResponse>}
 */
const methodDescriptor_AccountService_AdminAccountRestore = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAccountRestore',
  grpc.web.MethodType.UNARY,
  proto.social.account.RestoreAccount,
  proto.social.account.RestoreAccountResponse,
  /**
   * @param {!proto.social.account.RestoreAccount} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.RestoreAccountResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.RestoreAccount} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.RestoreAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.RestoreAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAccountRestore =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountRestore',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountRestore,
      callback);
};


/**
 * @param {!proto.social.account.RestoreAccount} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.RestoreAccountResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAccountRestore =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountRestore',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountRestore);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.RestrictDocument,
 *   !proto.social.account.FetchRestrictsResponse>}
 */
const methodDescriptor_AccountService_AdminGetAccountRestricts = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetAccountRestricts',
  grpc.web.MethodType.UNARY,
  proto.social.account.RestrictDocument,
  proto.social.account.FetchRestrictsResponse,
  /**
   * @param {!proto.social.account.RestrictDocument} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.FetchRestrictsResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.RestrictDocument} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.FetchRestrictsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.FetchRestrictsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetAccountRestricts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetAccountRestricts',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetAccountRestricts,
      callback);
};


/**
 * @param {!proto.social.account.RestrictDocument} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.FetchRestrictsResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetAccountRestricts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetAccountRestricts',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetAccountRestricts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.RestrictDocument,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminDeleteAccountRestricts = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminDeleteAccountRestricts',
  grpc.web.MethodType.UNARY,
  proto.social.account.RestrictDocument,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.RestrictDocument} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.RestrictDocument} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminDeleteAccountRestricts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteAccountRestricts',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteAccountRestricts,
      callback);
};


/**
 * @param {!proto.social.account.RestrictDocument} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminDeleteAccountRestricts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteAccountRestricts',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteAccountRestricts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.FindRequest,
 *   !proto.social.account.AccountListResponse>}
 */
const methodDescriptor_AccountService_AdminFind = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminFind',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.FindRequest,
  proto.social.account.AccountListResponse,
  /**
   * @param {!proto.social.common.FindRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminFind =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminFind',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminFind,
      callback);
};


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminFind =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminFind',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminFind);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ToggleAccount,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminAccountDisable2fa = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAccountDisable2fa',
  grpc.web.MethodType.UNARY,
  proto.social.account.ToggleAccount,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ToggleAccount} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ToggleAccount} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAccountDisable2fa =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountDisable2fa',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountDisable2fa,
      callback);
};


/**
 * @param {!proto.social.account.ToggleAccount} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAccountDisable2fa =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountDisable2fa',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountDisable2fa);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminBulkDisableGuest = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminBulkDisableGuest',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminBulkDisableGuest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminBulkDisableGuest',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminBulkDisableGuest,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminBulkDisableGuest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminBulkDisableGuest',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminBulkDisableGuest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.account.CountResponse>}
 */
const methodDescriptor_AccountService_AdminCountGuest = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminCountGuest',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  proto.social.account.CountResponse,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.CountResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.CountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.CountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminCountGuest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminCountGuest',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminCountGuest,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.CountResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminCountGuest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminCountGuest',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminCountGuest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.account.Account>}
 */
const methodDescriptor_AccountService_AdminAccountCreate = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAccountCreate',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  proto.social.account.Account,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Account.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Account)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Account>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAccountCreate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountCreate',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountCreate,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Account>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAccountCreate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountCreate',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountCreate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AdminAccountChangePasswordRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminAccountChangePassword = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAccountChangePassword',
  grpc.web.MethodType.UNARY,
  proto.social.account.AdminAccountChangePasswordRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.AdminAccountChangePasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.AdminAccountChangePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAccountChangePassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountChangePassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountChangePassword,
      callback);
};


/**
 * @param {!proto.social.account.AdminAccountChangePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAccountChangePassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountChangePassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountChangePassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ToggleAccount,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminAccountSetAsOperator = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAccountSetAsOperator',
  grpc.web.MethodType.UNARY,
  proto.social.account.ToggleAccount,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ToggleAccount} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ToggleAccount} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAccountSetAsOperator =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountSetAsOperator',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountSetAsOperator,
      callback);
};


/**
 * @param {!proto.social.account.ToggleAccount} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAccountSetAsOperator =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountSetAsOperator',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountSetAsOperator);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.CustomFields,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminUpsertCustomFields = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUpsertCustomFields',
  grpc.web.MethodType.UNARY,
  proto.social.account.CustomFields,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.CustomFields} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.CustomFields} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUpsertCustomFields =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUpsertCustomFields',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpsertCustomFields,
      callback);
};


/**
 * @param {!proto.social.account.CustomFields} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUpsertCustomFields =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUpsertCustomFields',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpsertCustomFields);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.CustomFields,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminDeleteCustomFields = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminDeleteCustomFields',
  grpc.web.MethodType.UNARY,
  proto.social.account.CustomFields,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.CustomFields} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.CustomFields} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminDeleteCustomFields =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteCustomFields',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteCustomFields,
      callback);
};


/**
 * @param {!proto.social.account.CustomFields} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminDeleteCustomFields =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteCustomFields',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteCustomFields);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminAccountSetOperatorType = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAccountSetOperatorType',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAccountSetOperatorType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountSetOperatorType',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountSetOperatorType,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAccountSetOperatorType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAccountSetOperatorType',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAccountSetOperatorType);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.GetReportAbuseRequest,
 *   !proto.social.account.ReportedAbuseByList>}
 */
const methodDescriptor_AccountService_AdminGetReportAbuse = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetReportAbuse',
  grpc.web.MethodType.UNARY,
  proto.social.account.GetReportAbuseRequest,
  proto.social.account.ReportedAbuseByList,
  /**
   * @param {!proto.social.account.GetReportAbuseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ReportedAbuseByList.deserializeBinary
);


/**
 * @param {!proto.social.account.GetReportAbuseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ReportedAbuseByList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ReportedAbuseByList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetReportAbuse =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetReportAbuse',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetReportAbuse,
      callback);
};


/**
 * @param {!proto.social.account.GetReportAbuseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ReportedAbuseByList>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetReportAbuse =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetReportAbuse',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetReportAbuse);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.GetReportAbuseRequest,
 *   !proto.social.account.ReportAbuseListResponse>}
 */
const methodDescriptor_AccountService_AdminGetReportAbuseList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetReportAbuseList',
  grpc.web.MethodType.UNARY,
  proto.social.account.GetReportAbuseRequest,
  proto.social.account.ReportAbuseListResponse,
  /**
   * @param {!proto.social.account.GetReportAbuseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ReportAbuseListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.GetReportAbuseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ReportAbuseListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ReportAbuseListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetReportAbuseList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetReportAbuseList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetReportAbuseList,
      callback);
};


/**
 * @param {!proto.social.account.GetReportAbuseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ReportAbuseListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetReportAbuseList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetReportAbuseList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetReportAbuseList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ReportAbuse,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminDeleteReportAbuse = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminDeleteReportAbuse',
  grpc.web.MethodType.UNARY,
  proto.social.account.ReportAbuse,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ReportAbuse} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ReportAbuse} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminDeleteReportAbuse =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteReportAbuse',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteReportAbuse,
      callback);
};


/**
 * @param {!proto.social.account.ReportAbuse} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminDeleteReportAbuse =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteReportAbuse',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteReportAbuse);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ReportAbuse,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminReportAbuseIgnore = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminReportAbuseIgnore',
  grpc.web.MethodType.UNARY,
  proto.social.account.ReportAbuse,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ReportAbuse} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ReportAbuse} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminReportAbuseIgnore =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminReportAbuseIgnore',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminReportAbuseIgnore,
      callback);
};


/**
 * @param {!proto.social.account.ReportAbuse} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminReportAbuseIgnore =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminReportAbuseIgnore',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminReportAbuseIgnore);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.account.ReportAbuseCountResponseList>}
 */
const methodDescriptor_AccountService_AdminReportAbuseCount = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminReportAbuseCount',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  proto.social.account.ReportAbuseCountResponseList,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ReportAbuseCountResponseList.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ReportAbuseCountResponseList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ReportAbuseCountResponseList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminReportAbuseCount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminReportAbuseCount',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminReportAbuseCount,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ReportAbuseCountResponseList>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminReportAbuseCount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminReportAbuseCount',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminReportAbuseCount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AdminUsersReportRequest,
 *   !proto.social.common.ReportResponseList>}
 */
const methodDescriptor_AccountService_AdminUsersReport = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUsersReport',
  grpc.web.MethodType.UNARY,
  proto.social.account.AdminUsersReportRequest,
  services_common_common_pb.ReportResponseList,
  /**
   * @param {!proto.social.account.AdminUsersReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.ReportResponseList.deserializeBinary
);


/**
 * @param {!proto.social.account.AdminUsersReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.ReportResponseList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.ReportResponseList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUsersReport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUsersReport',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUsersReport,
      callback);
};


/**
 * @param {!proto.social.account.AdminUsersReportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.ReportResponseList>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUsersReport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUsersReport',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUsersReport);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ClientVersion,
 *   !proto.social.account.ClientVersion>}
 */
const methodDescriptor_AccountService_AdminCreateClientVersion = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminCreateClientVersion',
  grpc.web.MethodType.UNARY,
  proto.social.account.ClientVersion,
  proto.social.account.ClientVersion,
  /**
   * @param {!proto.social.account.ClientVersion} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ClientVersion.deserializeBinary
);


/**
 * @param {!proto.social.account.ClientVersion} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ClientVersion)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ClientVersion>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminCreateClientVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminCreateClientVersion',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminCreateClientVersion,
      callback);
};


/**
 * @param {!proto.social.account.ClientVersion} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ClientVersion>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminCreateClientVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminCreateClientVersion',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminCreateClientVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ClientVersion,
 *   !proto.social.account.ClientVersion>}
 */
const methodDescriptor_AccountService_AdminUpdateClientVersion = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUpdateClientVersion',
  grpc.web.MethodType.UNARY,
  proto.social.account.ClientVersion,
  proto.social.account.ClientVersion,
  /**
   * @param {!proto.social.account.ClientVersion} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ClientVersion.deserializeBinary
);


/**
 * @param {!proto.social.account.ClientVersion} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ClientVersion)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ClientVersion>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUpdateClientVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUpdateClientVersion',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpdateClientVersion,
      callback);
};


/**
 * @param {!proto.social.account.ClientVersion} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ClientVersion>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUpdateClientVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUpdateClientVersion',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpdateClientVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ClientVersion,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminDeleteClientVersion = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminDeleteClientVersion',
  grpc.web.MethodType.UNARY,
  proto.social.account.ClientVersion,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ClientVersion} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ClientVersion} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminDeleteClientVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteClientVersion',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteClientVersion,
      callback);
};


/**
 * @param {!proto.social.account.ClientVersion} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminDeleteClientVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteClientVersion',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteClientVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ClientVersionListRequest,
 *   !proto.social.account.ClientVersionListResponse>}
 */
const methodDescriptor_AccountService_AdminClientVersionList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminClientVersionList',
  grpc.web.MethodType.UNARY,
  proto.social.account.ClientVersionListRequest,
  proto.social.account.ClientVersionListResponse,
  /**
   * @param {!proto.social.account.ClientVersionListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ClientVersionListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.ClientVersionListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ClientVersionListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ClientVersionListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminClientVersionList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminClientVersionList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminClientVersionList,
      callback);
};


/**
 * @param {!proto.social.account.ClientVersionListRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ClientVersionListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminClientVersionList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminClientVersionList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminClientVersionList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ClientVersionHistoryRequest,
 *   !proto.social.account.ClientVersionListResponse>}
 */
const methodDescriptor_AccountService_AdminClientVersionHistoryList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminClientVersionHistoryList',
  grpc.web.MethodType.UNARY,
  proto.social.account.ClientVersionHistoryRequest,
  proto.social.account.ClientVersionListResponse,
  /**
   * @param {!proto.social.account.ClientVersionHistoryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ClientVersionListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.ClientVersionHistoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ClientVersionListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ClientVersionListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminClientVersionHistoryList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminClientVersionHistoryList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminClientVersionHistoryList,
      callback);
};


/**
 * @param {!proto.social.account.ClientVersionHistoryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ClientVersionListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminClientVersionHistoryList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminClientVersionHistoryList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminClientVersionHistoryList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Network,
 *   !proto.social.account.Network>}
 */
const methodDescriptor_AccountService_AdminCreateNetwork = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminCreateNetwork',
  grpc.web.MethodType.UNARY,
  proto.social.account.Network,
  proto.social.account.Network,
  /**
   * @param {!proto.social.account.Network} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Network.deserializeBinary
);


/**
 * @param {!proto.social.account.Network} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Network)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Network>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminCreateNetwork =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminCreateNetwork',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminCreateNetwork,
      callback);
};


/**
 * @param {!proto.social.account.Network} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Network>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminCreateNetwork =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminCreateNetwork',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminCreateNetwork);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Network,
 *   !proto.social.account.Network>}
 */
const methodDescriptor_AccountService_AdminUpdateNetwork = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUpdateNetwork',
  grpc.web.MethodType.UNARY,
  proto.social.account.Network,
  proto.social.account.Network,
  /**
   * @param {!proto.social.account.Network} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Network.deserializeBinary
);


/**
 * @param {!proto.social.account.Network} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Network)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Network>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUpdateNetwork =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUpdateNetwork',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpdateNetwork,
      callback);
};


/**
 * @param {!proto.social.account.Network} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Network>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUpdateNetwork =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUpdateNetwork',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpdateNetwork);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Network,
 *   !proto.social.account.Network>}
 */
const methodDescriptor_AccountService_AdminDeleteNetwork = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminDeleteNetwork',
  grpc.web.MethodType.UNARY,
  proto.social.account.Network,
  proto.social.account.Network,
  /**
   * @param {!proto.social.account.Network} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Network.deserializeBinary
);


/**
 * @param {!proto.social.account.Network} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Network)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Network>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminDeleteNetwork =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteNetwork',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteNetwork,
      callback);
};


/**
 * @param {!proto.social.account.Network} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Network>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminDeleteNetwork =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteNetwork',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteNetwork);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Network,
 *   !proto.social.account.Network>}
 */
const methodDescriptor_AccountService_AdminGetNetwork = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetNetwork',
  grpc.web.MethodType.UNARY,
  proto.social.account.Network,
  proto.social.account.Network,
  /**
   * @param {!proto.social.account.Network} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Network.deserializeBinary
);


/**
 * @param {!proto.social.account.Network} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Network)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Network>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetNetwork =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetNetwork',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetNetwork,
      callback);
};


/**
 * @param {!proto.social.account.Network} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Network>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetNetwork =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetNetwork',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetNetwork);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Pagination,
 *   !proto.social.account.NetworkListResponse>}
 */
const methodDescriptor_AccountService_AdminGetNetworkList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetNetworkList',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Pagination,
  proto.social.account.NetworkListResponse,
  /**
   * @param {!proto.social.common.Pagination} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.NetworkListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.NetworkListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.NetworkListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetNetworkList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetNetworkList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetNetworkList,
      callback);
};


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.NetworkListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetNetworkList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetNetworkList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetNetworkList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.common.UploadMediaResponse>}
 */
const methodDescriptor_AccountService_AdminUploadNetworkProfile = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUploadNetworkProfile',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  services_common_common_pb.UploadMediaResponse,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.UploadMediaResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.UploadMediaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.UploadMediaResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUploadNetworkProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUploadNetworkProfile',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUploadNetworkProfile,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.UploadMediaResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUploadNetworkProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUploadNetworkProfile',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUploadNetworkProfile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.FindRequest,
 *   !proto.social.account.OrganizationRoleListResponse>}
 */
const methodDescriptor_AccountService_AdminFindOrganizationRoleList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminFindOrganizationRoleList',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.FindRequest,
  proto.social.account.OrganizationRoleListResponse,
  /**
   * @param {!proto.social.common.FindRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.OrganizationRoleListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.OrganizationRoleListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.OrganizationRoleListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminFindOrganizationRoleList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminFindOrganizationRoleList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminFindOrganizationRoleList,
      callback);
};


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.OrganizationRoleListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminFindOrganizationRoleList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminFindOrganizationRoleList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminFindOrganizationRoleList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.FindRequest,
 *   !proto.social.account.OrganizationNameListResponse>}
 */
const methodDescriptor_AccountService_AdminFindOrganizationNameList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminFindOrganizationNameList',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.FindRequest,
  proto.social.account.OrganizationNameListResponse,
  /**
   * @param {!proto.social.common.FindRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.OrganizationNameListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.OrganizationNameListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.OrganizationNameListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminFindOrganizationNameList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminFindOrganizationNameList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminFindOrganizationNameList,
      callback);
};


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.OrganizationNameListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminFindOrganizationNameList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminFindOrganizationNameList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminFindOrganizationNameList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.FindRoomPositionListRequest,
 *   !proto.social.account.RoomPositionListResponse>}
 */
const methodDescriptor_AccountService_AdminFindRoomPositionList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminFindRoomPositionList',
  grpc.web.MethodType.UNARY,
  proto.social.account.FindRoomPositionListRequest,
  proto.social.account.RoomPositionListResponse,
  /**
   * @param {!proto.social.account.FindRoomPositionListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.RoomPositionListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.FindRoomPositionListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.RoomPositionListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.RoomPositionListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminFindRoomPositionList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminFindRoomPositionList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminFindRoomPositionList,
      callback);
};


/**
 * @param {!proto.social.account.FindRoomPositionListRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.RoomPositionListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminFindRoomPositionList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminFindRoomPositionList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminFindRoomPositionList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.RoomPosition,
 *   !proto.social.account.RoomPosition>}
 */
const methodDescriptor_AccountService_AdminUpsertRoomPosition = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUpsertRoomPosition',
  grpc.web.MethodType.UNARY,
  proto.social.account.RoomPosition,
  proto.social.account.RoomPosition,
  /**
   * @param {!proto.social.account.RoomPosition} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.RoomPosition.deserializeBinary
);


/**
 * @param {!proto.social.account.RoomPosition} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.RoomPosition)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.RoomPosition>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUpsertRoomPosition =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUpsertRoomPosition',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpsertRoomPosition,
      callback);
};


/**
 * @param {!proto.social.account.RoomPosition} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.RoomPosition>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUpsertRoomPosition =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUpsertRoomPosition',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpsertRoomPosition);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.RoomPosition,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminDeleteRoomPosition = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminDeleteRoomPosition',
  grpc.web.MethodType.UNARY,
  proto.social.account.RoomPosition,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.RoomPosition} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.RoomPosition} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminDeleteRoomPosition =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteRoomPosition',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteRoomPosition,
      callback);
};


/**
 * @param {!proto.social.account.RoomPosition} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminDeleteRoomPosition =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteRoomPosition',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteRoomPosition);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.FindRequest,
 *   !proto.social.account.OrganizationRoleListResponse>}
 */
const methodDescriptor_AccountService_FindOrganizationRoleList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/FindOrganizationRoleList',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.FindRequest,
  proto.social.account.OrganizationRoleListResponse,
  /**
   * @param {!proto.social.common.FindRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.OrganizationRoleListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.OrganizationRoleListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.OrganizationRoleListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.findOrganizationRoleList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/FindOrganizationRoleList',
      request,
      metadata || {},
      methodDescriptor_AccountService_FindOrganizationRoleList,
      callback);
};


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.OrganizationRoleListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.findOrganizationRoleList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/FindOrganizationRoleList',
      request,
      metadata || {},
      methodDescriptor_AccountService_FindOrganizationRoleList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.FindRequest,
 *   !proto.social.account.OrganizationNameListResponse>}
 */
const methodDescriptor_AccountService_FindOrganizationNameList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/FindOrganizationNameList',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.FindRequest,
  proto.social.account.OrganizationNameListResponse,
  /**
   * @param {!proto.social.common.FindRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.OrganizationNameListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.OrganizationNameListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.OrganizationNameListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.findOrganizationNameList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/FindOrganizationNameList',
      request,
      metadata || {},
      methodDescriptor_AccountService_FindOrganizationNameList,
      callback);
};


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.OrganizationNameListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.findOrganizationNameList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/FindOrganizationNameList',
      request,
      metadata || {},
      methodDescriptor_AccountService_FindOrganizationNameList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.account.Account>}
 */
const methodDescriptor_AccountService_AdminRegisterUser = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminRegisterUser',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  proto.social.account.Account,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Account.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Account)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Account>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminRegisterUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminRegisterUser',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminRegisterUser,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Account>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminRegisterUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminRegisterUser',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminRegisterUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.account.Account>}
 */
const methodDescriptor_AccountService_AdminUpdateInvitedUser = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUpdateInvitedUser',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  proto.social.account.Account,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Account.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Account)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Account>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUpdateInvitedUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUpdateInvitedUser',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpdateInvitedUser,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Account>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUpdateInvitedUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUpdateInvitedUser',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpdateInvitedUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.InvitedUsersListRequest,
 *   !proto.social.account.AccountListResponse>}
 */
const methodDescriptor_AccountService_AdminInvitedUsersList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminInvitedUsersList',
  grpc.web.MethodType.UNARY,
  proto.social.account.InvitedUsersListRequest,
  proto.social.account.AccountListResponse,
  /**
   * @param {!proto.social.account.InvitedUsersListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.InvitedUsersListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminInvitedUsersList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminInvitedUsersList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminInvitedUsersList,
      callback);
};


/**
 * @param {!proto.social.account.InvitedUsersListRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminInvitedUsersList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminInvitedUsersList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminInvitedUsersList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.common.UploadMediaResponse>}
 */
const methodDescriptor_AccountService_AdminUploadProfilePhoto = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUploadProfilePhoto',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  services_common_common_pb.UploadMediaResponse,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.UploadMediaResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.UploadMediaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.UploadMediaResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUploadProfilePhoto =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUploadProfilePhoto',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUploadProfilePhoto,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.UploadMediaResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUploadProfilePhoto =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUploadProfilePhoto',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUploadProfilePhoto);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.UsernameTakeOverRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminUsernameTakeOver = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUsernameTakeOver',
  grpc.web.MethodType.UNARY,
  proto.social.account.UsernameTakeOverRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.UsernameTakeOverRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.UsernameTakeOverRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUsernameTakeOver =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUsernameTakeOver',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUsernameTakeOver,
      callback);
};


/**
 * @param {!proto.social.account.UsernameTakeOverRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUsernameTakeOver =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUsernameTakeOver',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUsernameTakeOver);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Username,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminBlockUsername = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminBlockUsername',
  grpc.web.MethodType.UNARY,
  proto.social.account.Username,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Username} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Username} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminBlockUsername =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminBlockUsername',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminBlockUsername,
      callback);
};


/**
 * @param {!proto.social.account.Username} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminBlockUsername =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminBlockUsername',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminBlockUsername);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Pagination,
 *   !proto.social.account.UsernameBlockList>}
 */
const methodDescriptor_AccountService_AdminUsernameBlockList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUsernameBlockList',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Pagination,
  proto.social.account.UsernameBlockList,
  /**
   * @param {!proto.social.common.Pagination} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.UsernameBlockList.deserializeBinary
);


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.UsernameBlockList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.UsernameBlockList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUsernameBlockList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUsernameBlockList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUsernameBlockList,
      callback);
};


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.UsernameBlockList>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUsernameBlockList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUsernameBlockList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUsernameBlockList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Username,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminUnblockUsername = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUnblockUsername',
  grpc.web.MethodType.UNARY,
  proto.social.account.Username,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Username} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Username} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUnblockUsername =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUnblockUsername',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUnblockUsername,
      callback);
};


/**
 * @param {!proto.social.account.Username} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUnblockUsername =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUnblockUsername',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUnblockUsername);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.SendOtpRequest,
 *   !proto.social.account.SendOtpResponse>}
 */
const methodDescriptor_AccountService_AdminSendOTP = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminSendOTP',
  grpc.web.MethodType.UNARY,
  proto.social.account.SendOtpRequest,
  proto.social.account.SendOtpResponse,
  /**
   * @param {!proto.social.account.SendOtpRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.SendOtpResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.SendOtpRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.SendOtpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.SendOtpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminSendOTP =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminSendOTP',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminSendOTP,
      callback);
};


/**
 * @param {!proto.social.account.SendOtpRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.SendOtpResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminSendOTP =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminSendOTP',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminSendOTP);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.VerifyOtpRequest,
 *   !proto.social.account.VerifyOtpResponse>}
 */
const methodDescriptor_AccountService_AdminVerifyOTP = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminVerifyOTP',
  grpc.web.MethodType.UNARY,
  proto.social.account.VerifyOtpRequest,
  proto.social.account.VerifyOtpResponse,
  /**
   * @param {!proto.social.account.VerifyOtpRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.VerifyOtpResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.VerifyOtpRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.VerifyOtpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.VerifyOtpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminVerifyOTP =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminVerifyOTP',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminVerifyOTP,
      callback);
};


/**
 * @param {!proto.social.account.VerifyOtpRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.VerifyOtpResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminVerifyOTP =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminVerifyOTP',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminVerifyOTP);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Verify2faRequest,
 *   !proto.social.account.VerifyOtpResponse>}
 */
const methodDescriptor_AccountService_AdminVerify2fa = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminVerify2fa',
  grpc.web.MethodType.UNARY,
  proto.social.account.Verify2faRequest,
  proto.social.account.VerifyOtpResponse,
  /**
   * @param {!proto.social.account.Verify2faRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.VerifyOtpResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.Verify2faRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.VerifyOtpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.VerifyOtpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminVerify2fa =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminVerify2fa',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminVerify2fa,
      callback);
};


/**
 * @param {!proto.social.account.Verify2faRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.VerifyOtpResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminVerify2fa =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminVerify2fa',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminVerify2fa);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Recover2faRequest,
 *   !proto.social.account.Recover2faResponse>}
 */
const methodDescriptor_AccountService_AdminRecover2fa = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminRecover2fa',
  grpc.web.MethodType.UNARY,
  proto.social.account.Recover2faRequest,
  proto.social.account.Recover2faResponse,
  /**
   * @param {!proto.social.account.Recover2faRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Recover2faResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.Recover2faRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Recover2faResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Recover2faResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminRecover2fa =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminRecover2fa',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminRecover2fa,
      callback);
};


/**
 * @param {!proto.social.account.Recover2faRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Recover2faResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminRecover2fa =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminRecover2fa',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminRecover2fa);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.TotpCodeRequest,
 *   !proto.social.account.VerifyOtpResponse>}
 */
const methodDescriptor_AccountService_AdminVerifyTotp = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminVerifyTotp',
  grpc.web.MethodType.UNARY,
  proto.social.account.TotpCodeRequest,
  proto.social.account.VerifyOtpResponse,
  /**
   * @param {!proto.social.account.TotpCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.VerifyOtpResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.TotpCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.VerifyOtpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.VerifyOtpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminVerifyTotp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminVerifyTotp',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminVerifyTotp,
      callback);
};


/**
 * @param {!proto.social.account.TotpCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.VerifyOtpResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminVerifyTotp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminVerifyTotp',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminVerifyTotp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.TotpRecoveryCodeRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminRecoverTotp = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminRecoverTotp',
  grpc.web.MethodType.UNARY,
  proto.social.account.TotpRecoveryCodeRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.TotpRecoveryCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.TotpRecoveryCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminRecoverTotp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminRecoverTotp',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminRecoverTotp,
      callback);
};


/**
 * @param {!proto.social.account.TotpRecoveryCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminRecoverTotp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminRecoverTotp',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminRecoverTotp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Pagination,
 *   !proto.social.account.NetworkTokenListResponse>}
 */
const methodDescriptor_AccountService_AdminGetAllNetworks = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetAllNetworks',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Pagination,
  proto.social.account.NetworkTokenListResponse,
  /**
   * @param {!proto.social.common.Pagination} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.NetworkTokenListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.NetworkTokenListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.NetworkTokenListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetAllNetworks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetAllNetworks',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetAllNetworks,
      callback);
};


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.NetworkTokenListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetAllNetworks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetAllNetworks',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetAllNetworks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.LoginRequest,
 *   !proto.social.account.VerifyOtpResponse>}
 */
const methodDescriptor_AccountService_AdminLogin = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminLogin',
  grpc.web.MethodType.UNARY,
  proto.social.account.LoginRequest,
  proto.social.account.VerifyOtpResponse,
  /**
   * @param {!proto.social.account.LoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.VerifyOtpResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.VerifyOtpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.VerifyOtpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminLogin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminLogin',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminLogin,
      callback);
};


/**
 * @param {!proto.social.account.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.VerifyOtpResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminLogin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminLogin',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminLogin);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.FindRequest,
 *   !proto.social.account.ChatUserListResponse>}
 */
const methodDescriptor_AccountService_AdminChatUsersList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminChatUsersList',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.FindRequest,
  proto.social.account.ChatUserListResponse,
  /**
   * @param {!proto.social.common.FindRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ChatUserListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ChatUserListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ChatUserListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminChatUsersList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminChatUsersList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminChatUsersList,
      callback);
};


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ChatUserListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminChatUsersList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminChatUsersList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminChatUsersList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.FindRequest,
 *   !proto.social.account.ChatRoomListResponse>}
 */
const methodDescriptor_AccountService_AdminChatRoomList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminChatRoomList',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.FindRequest,
  proto.social.account.ChatRoomListResponse,
  /**
   * @param {!proto.social.common.FindRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ChatRoomListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ChatRoomListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ChatRoomListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminChatRoomList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminChatRoomList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminChatRoomList,
      callback);
};


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ChatRoomListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminChatRoomList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminChatRoomList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminChatRoomList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ChatRoom,
 *   !proto.social.account.ChatRoom>}
 */
const methodDescriptor_AccountService_AdminChatRoomInfo = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminChatRoomInfo',
  grpc.web.MethodType.UNARY,
  proto.social.account.ChatRoom,
  proto.social.account.ChatRoom,
  /**
   * @param {!proto.social.account.ChatRoom} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ChatRoom.deserializeBinary
);


/**
 * @param {!proto.social.account.ChatRoom} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ChatRoom)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ChatRoom>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminChatRoomInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminChatRoomInfo',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminChatRoomInfo,
      callback);
};


/**
 * @param {!proto.social.account.ChatRoom} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ChatRoom>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminChatRoomInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminChatRoomInfo',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminChatRoomInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.BotCommand,
 *   !proto.social.account.BotCommand>}
 */
const methodDescriptor_AccountService_AdminCreateBotCommand = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminCreateBotCommand',
  grpc.web.MethodType.UNARY,
  proto.social.account.BotCommand,
  proto.social.account.BotCommand,
  /**
   * @param {!proto.social.account.BotCommand} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.BotCommand.deserializeBinary
);


/**
 * @param {!proto.social.account.BotCommand} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.BotCommand)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.BotCommand>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminCreateBotCommand =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminCreateBotCommand',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminCreateBotCommand,
      callback);
};


/**
 * @param {!proto.social.account.BotCommand} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.BotCommand>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminCreateBotCommand =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminCreateBotCommand',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminCreateBotCommand);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.BotCommand,
 *   !proto.social.account.BotCommand>}
 */
const methodDescriptor_AccountService_AdminUpdateBotCommand = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUpdateBotCommand',
  grpc.web.MethodType.UNARY,
  proto.social.account.BotCommand,
  proto.social.account.BotCommand,
  /**
   * @param {!proto.social.account.BotCommand} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.BotCommand.deserializeBinary
);


/**
 * @param {!proto.social.account.BotCommand} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.BotCommand)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.BotCommand>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUpdateBotCommand =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUpdateBotCommand',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpdateBotCommand,
      callback);
};


/**
 * @param {!proto.social.account.BotCommand} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.BotCommand>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUpdateBotCommand =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUpdateBotCommand',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpdateBotCommand);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.BotCommand,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminDeleteBotCommand = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminDeleteBotCommand',
  grpc.web.MethodType.UNARY,
  proto.social.account.BotCommand,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.BotCommand} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.BotCommand} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminDeleteBotCommand =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteBotCommand',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteBotCommand,
      callback);
};


/**
 * @param {!proto.social.account.BotCommand} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminDeleteBotCommand =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteBotCommand',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteBotCommand);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.BotCommand,
 *   !proto.social.account.BotCommand>}
 */
const methodDescriptor_AccountService_AdminGetBotCommand = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetBotCommand',
  grpc.web.MethodType.UNARY,
  proto.social.account.BotCommand,
  proto.social.account.BotCommand,
  /**
   * @param {!proto.social.account.BotCommand} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.BotCommand.deserializeBinary
);


/**
 * @param {!proto.social.account.BotCommand} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.BotCommand)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.BotCommand>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetBotCommand =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetBotCommand',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetBotCommand,
      callback);
};


/**
 * @param {!proto.social.account.BotCommand} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.BotCommand>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetBotCommand =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetBotCommand',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetBotCommand);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.BotCommand,
 *   !proto.social.account.BotCommandListResponse>}
 */
const methodDescriptor_AccountService_AdminGetBotCommandList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetBotCommandList',
  grpc.web.MethodType.UNARY,
  proto.social.account.BotCommand,
  proto.social.account.BotCommandListResponse,
  /**
   * @param {!proto.social.account.BotCommand} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.BotCommandListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.BotCommand} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.BotCommandListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.BotCommandListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetBotCommandList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetBotCommandList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetBotCommandList,
      callback);
};


/**
 * @param {!proto.social.account.BotCommand} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.BotCommandListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetBotCommandList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetBotCommandList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetBotCommandList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ChatBot,
 *   !proto.social.account.ChatBot>}
 */
const methodDescriptor_AccountService_AdminCreateBot = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminCreateBot',
  grpc.web.MethodType.UNARY,
  proto.social.account.ChatBot,
  proto.social.account.ChatBot,
  /**
   * @param {!proto.social.account.ChatBot} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ChatBot.deserializeBinary
);


/**
 * @param {!proto.social.account.ChatBot} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ChatBot)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ChatBot>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminCreateBot =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminCreateBot',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminCreateBot,
      callback);
};


/**
 * @param {!proto.social.account.ChatBot} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ChatBot>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminCreateBot =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminCreateBot',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminCreateBot);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ChatBot,
 *   !proto.social.account.ChatBot>}
 */
const methodDescriptor_AccountService_AdminUpdateBot = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUpdateBot',
  grpc.web.MethodType.UNARY,
  proto.social.account.ChatBot,
  proto.social.account.ChatBot,
  /**
   * @param {!proto.social.account.ChatBot} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ChatBot.deserializeBinary
);


/**
 * @param {!proto.social.account.ChatBot} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ChatBot)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ChatBot>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUpdateBot =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUpdateBot',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpdateBot,
      callback);
};


/**
 * @param {!proto.social.account.ChatBot} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ChatBot>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUpdateBot =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUpdateBot',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpdateBot);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ChatBot,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminDeleteBot = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminDeleteBot',
  grpc.web.MethodType.UNARY,
  proto.social.account.ChatBot,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ChatBot} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ChatBot} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminDeleteBot =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteBot',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteBot,
      callback);
};


/**
 * @param {!proto.social.account.ChatBot} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminDeleteBot =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteBot',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteBot);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ChatBot,
 *   !proto.social.account.ChatBot>}
 */
const methodDescriptor_AccountService_AdminGetBot = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetBot',
  grpc.web.MethodType.UNARY,
  proto.social.account.ChatBot,
  proto.social.account.ChatBot,
  /**
   * @param {!proto.social.account.ChatBot} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ChatBot.deserializeBinary
);


/**
 * @param {!proto.social.account.ChatBot} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ChatBot)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ChatBot>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetBot =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetBot',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetBot,
      callback);
};


/**
 * @param {!proto.social.account.ChatBot} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ChatBot>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetBot =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetBot',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetBot);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Pagination,
 *   !proto.social.account.ChatBotListResponse>}
 */
const methodDescriptor_AccountService_AdminGetBotList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetBotList',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Pagination,
  proto.social.account.ChatBotListResponse,
  /**
   * @param {!proto.social.common.Pagination} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ChatBotListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ChatBotListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ChatBotListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetBotList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetBotList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetBotList,
      callback);
};


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ChatBotListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetBotList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetBotList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetBotList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Role,
 *   !proto.social.account.Role>}
 */
const methodDescriptor_AccountService_AdminCreateRole = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminCreateRole',
  grpc.web.MethodType.UNARY,
  proto.social.account.Role,
  proto.social.account.Role,
  /**
   * @param {!proto.social.account.Role} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Role.deserializeBinary
);


/**
 * @param {!proto.social.account.Role} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Role)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Role>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminCreateRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminCreateRole',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminCreateRole,
      callback);
};


/**
 * @param {!proto.social.account.Role} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Role>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminCreateRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminCreateRole',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminCreateRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Role,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminUpdateRole = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUpdateRole',
  grpc.web.MethodType.UNARY,
  proto.social.account.Role,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Role} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Role} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUpdateRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUpdateRole',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpdateRole,
      callback);
};


/**
 * @param {!proto.social.account.Role} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUpdateRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUpdateRole',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpdateRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Role,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminDeleteRole = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminDeleteRole',
  grpc.web.MethodType.UNARY,
  proto.social.account.Role,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Role} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Role} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminDeleteRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteRole',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteRole,
      callback);
};


/**
 * @param {!proto.social.account.Role} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminDeleteRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteRole',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Pagination,
 *   !proto.social.account.RoleListResponse>}
 */
const methodDescriptor_AccountService_AdminGetAllRoles = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetAllRoles',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Pagination,
  proto.social.account.RoleListResponse,
  /**
   * @param {!proto.social.common.Pagination} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.RoleListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.RoleListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.RoleListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetAllRoles =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetAllRoles',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetAllRoles,
      callback);
};


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.RoleListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetAllRoles =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetAllRoles',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetAllRoles);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AssignRoleRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminAssignRole = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAssignRole',
  grpc.web.MethodType.UNARY,
  proto.social.account.AssignRoleRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.AssignRoleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.AssignRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAssignRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAssignRole',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAssignRole,
      callback);
};


/**
 * @param {!proto.social.account.AssignRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAssignRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAssignRole',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAssignRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AssignRoleRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminUnassignRole = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUnassignRole',
  grpc.web.MethodType.UNARY,
  proto.social.account.AssignRoleRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.AssignRoleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.AssignRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUnassignRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUnassignRole',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUnassignRole,
      callback);
};


/**
 * @param {!proto.social.account.AssignRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUnassignRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUnassignRole',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUnassignRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.RoleAccountRequest,
 *   !proto.social.account.AccountListResponse>}
 */
const methodDescriptor_AccountService_AdminGetAllAccountsInRole = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetAllAccountsInRole',
  grpc.web.MethodType.UNARY,
  proto.social.account.RoleAccountRequest,
  proto.social.account.AccountListResponse,
  /**
   * @param {!proto.social.account.RoleAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AccountListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.RoleAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AccountListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AccountListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetAllAccountsInRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetAllAccountsInRole',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetAllAccountsInRole,
      callback);
};


/**
 * @param {!proto.social.account.RoleAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AccountListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetAllAccountsInRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetAllAccountsInRole',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetAllAccountsInRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AccountRoleRequest,
 *   !proto.social.account.RoleListResponse>}
 */
const methodDescriptor_AccountService_AdminGetAccountRoles = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetAccountRoles',
  grpc.web.MethodType.UNARY,
  proto.social.account.AccountRoleRequest,
  proto.social.account.RoleListResponse,
  /**
   * @param {!proto.social.account.AccountRoleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.RoleListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.AccountRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.RoleListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.RoleListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetAccountRoles =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetAccountRoles',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetAccountRoles,
      callback);
};


/**
 * @param {!proto.social.account.AccountRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.RoleListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetAccountRoles =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetAccountRoles',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetAccountRoles);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Permission,
 *   !proto.social.account.Permission>}
 */
const methodDescriptor_AccountService_AdminCreatePermission = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminCreatePermission',
  grpc.web.MethodType.UNARY,
  proto.social.account.Permission,
  proto.social.account.Permission,
  /**
   * @param {!proto.social.account.Permission} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.Permission.deserializeBinary
);


/**
 * @param {!proto.social.account.Permission} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.Permission)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.Permission>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminCreatePermission =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminCreatePermission',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminCreatePermission,
      callback);
};


/**
 * @param {!proto.social.account.Permission} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.Permission>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminCreatePermission =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminCreatePermission',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminCreatePermission);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Permission,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminUpdatePermission = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUpdatePermission',
  grpc.web.MethodType.UNARY,
  proto.social.account.Permission,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Permission} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Permission} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUpdatePermission =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUpdatePermission',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpdatePermission,
      callback);
};


/**
 * @param {!proto.social.account.Permission} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUpdatePermission =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUpdatePermission',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpdatePermission);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Permission,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminDeletePermission = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminDeletePermission',
  grpc.web.MethodType.UNARY,
  proto.social.account.Permission,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Permission} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Permission} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminDeletePermission =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminDeletePermission',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeletePermission,
      callback);
};


/**
 * @param {!proto.social.account.Permission} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminDeletePermission =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminDeletePermission',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeletePermission);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AssignPermissionRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminAssignPermissionToRole = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAssignPermissionToRole',
  grpc.web.MethodType.UNARY,
  proto.social.account.AssignPermissionRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.AssignPermissionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.AssignPermissionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAssignPermissionToRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAssignPermissionToRole',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAssignPermissionToRole,
      callback);
};


/**
 * @param {!proto.social.account.AssignPermissionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAssignPermissionToRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAssignPermissionToRole',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAssignPermissionToRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AssignPermissionRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminRemovePermissionFromRole = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminRemovePermissionFromRole',
  grpc.web.MethodType.UNARY,
  proto.social.account.AssignPermissionRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.AssignPermissionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.AssignPermissionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminRemovePermissionFromRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminRemovePermissionFromRole',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminRemovePermissionFromRole,
      callback);
};


/**
 * @param {!proto.social.account.AssignPermissionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminRemovePermissionFromRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminRemovePermissionFromRole',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminRemovePermissionFromRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.account.AdminOtpListResponse>}
 */
const methodDescriptor_AccountService_AdminGetOtpList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetOtpList',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  proto.social.account.AdminOtpListResponse,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AdminOtpListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AdminOtpListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AdminOtpListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetOtpList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetOtpList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetOtpList,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AdminOtpListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetOtpList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetOtpList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetOtpList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ContactRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminAddWhiteListContact = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAddWhiteListContact',
  grpc.web.MethodType.UNARY,
  proto.social.account.ContactRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ContactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ContactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAddWhiteListContact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAddWhiteListContact',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAddWhiteListContact,
      callback);
};


/**
 * @param {!proto.social.account.ContactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAddWhiteListContact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAddWhiteListContact',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAddWhiteListContact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ContactRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminDeleteWhiteListContact = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminDeleteWhiteListContact',
  grpc.web.MethodType.UNARY,
  proto.social.account.ContactRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ContactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ContactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminDeleteWhiteListContact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteWhiteListContact',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteWhiteListContact,
      callback);
};


/**
 * @param {!proto.social.account.ContactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminDeleteWhiteListContact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteWhiteListContact',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteWhiteListContact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ContactRequest,
 *   !proto.social.account.ContactListResponse>}
 */
const methodDescriptor_AccountService_AdminFindWhiteListContact = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminFindWhiteListContact',
  grpc.web.MethodType.UNARY,
  proto.social.account.ContactRequest,
  proto.social.account.ContactListResponse,
  /**
   * @param {!proto.social.account.ContactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ContactListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.ContactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ContactListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ContactListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminFindWhiteListContact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminFindWhiteListContact',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminFindWhiteListContact,
      callback);
};


/**
 * @param {!proto.social.account.ContactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ContactListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminFindWhiteListContact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminFindWhiteListContact',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminFindWhiteListContact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Pagination,
 *   !proto.social.account.ContactListResponse>}
 */
const methodDescriptor_AccountService_AdminGetWhiteListContacts = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetWhiteListContacts',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Pagination,
  proto.social.account.ContactListResponse,
  /**
   * @param {!proto.social.common.Pagination} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ContactListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ContactListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ContactListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetWhiteListContacts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetWhiteListContacts',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetWhiteListContacts,
      callback);
};


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ContactListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetWhiteListContacts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetWhiteListContacts',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetWhiteListContacts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Role,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminRestoreDefaultPermissionsToRoles = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminRestoreDefaultPermissionsToRoles',
  grpc.web.MethodType.UNARY,
  proto.social.account.Role,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Role} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Role} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminRestoreDefaultPermissionsToRoles =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminRestoreDefaultPermissionsToRoles',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminRestoreDefaultPermissionsToRoles,
      callback);
};


/**
 * @param {!proto.social.account.Role} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminRestoreDefaultPermissionsToRoles =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminRestoreDefaultPermissionsToRoles',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminRestoreDefaultPermissionsToRoles);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.common.StringValue>}
 */
const methodDescriptor_AccountService_RootGetHWID = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RootGetHWID',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  services_common_common_pb.StringValue,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.StringValue.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.StringValue)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.StringValue>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.rootGetHWID =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RootGetHWID',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootGetHWID,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.StringValue>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.rootGetHWID =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RootGetHWID',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootGetHWID);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.StringValue,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_RootUpdateLicense = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RootUpdateLicense',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.StringValue,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.common.StringValue} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.common.StringValue} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.rootUpdateLicense =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RootUpdateLicense',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootUpdateLicense,
      callback);
};


/**
 * @param {!proto.social.common.StringValue} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.rootUpdateLicense =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RootUpdateLicense',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootUpdateLicense);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.account.LicenseStatusResponse>}
 */
const methodDescriptor_AccountService_AdminGetLicenseStatus = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetLicenseStatus',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  proto.social.account.LicenseStatusResponse,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.LicenseStatusResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.LicenseStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.LicenseStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetLicenseStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetLicenseStatus',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetLicenseStatus,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.LicenseStatusResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetLicenseStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetLicenseStatus',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetLicenseStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ToggleServiceRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_RootToggleService = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RootToggleService',
  grpc.web.MethodType.UNARY,
  proto.social.account.ToggleServiceRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ToggleServiceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ToggleServiceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.rootToggleService =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RootToggleService',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootToggleService,
      callback);
};


/**
 * @param {!proto.social.account.ToggleServiceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.rootToggleService =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RootToggleService',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootToggleService);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.ToggleMethodRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_RootToggleMethod = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RootToggleMethod',
  grpc.web.MethodType.UNARY,
  proto.social.account.ToggleMethodRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.ToggleMethodRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.ToggleMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.rootToggleMethod =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RootToggleMethod',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootToggleMethod,
      callback);
};


/**
 * @param {!proto.social.account.ToggleMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.rootToggleMethod =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RootToggleMethod',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootToggleMethod);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Page,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_RootTogglePage = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RootTogglePage',
  grpc.web.MethodType.UNARY,
  proto.social.account.Page,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.Page} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.Page} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.rootTogglePage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RootTogglePage',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootTogglePage,
      callback);
};


/**
 * @param {!proto.social.account.Page} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.rootTogglePage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RootTogglePage',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootTogglePage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.account.MethodListResponse>}
 */
const methodDescriptor_AccountService_RootGetAllServices = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RootGetAllServices',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  proto.social.account.MethodListResponse,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.MethodListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.MethodListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.MethodListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.rootGetAllServices =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RootGetAllServices',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootGetAllServices,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.MethodListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.rootGetAllServices =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RootGetAllServices',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootGetAllServices);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.InactiveListRequest,
 *   !proto.social.account.InactiveListResponse>}
 */
const methodDescriptor_AccountService_InactiveFeatureList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/InactiveFeatureList',
  grpc.web.MethodType.UNARY,
  proto.social.account.InactiveListRequest,
  proto.social.account.InactiveListResponse,
  /**
   * @param {!proto.social.account.InactiveListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.InactiveListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.InactiveListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.InactiveListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.InactiveListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.inactiveFeatureList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/InactiveFeatureList',
      request,
      metadata || {},
      methodDescriptor_AccountService_InactiveFeatureList,
      callback);
};


/**
 * @param {!proto.social.account.InactiveListRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.InactiveListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.inactiveFeatureList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/InactiveFeatureList',
      request,
      metadata || {},
      methodDescriptor_AccountService_InactiveFeatureList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.account.ConfigResponse>}
 */
const methodDescriptor_AccountService_AdminGetConfigs = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetConfigs',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  proto.social.account.ConfigResponse,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ConfigResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetConfigs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetConfigs',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetConfigs,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ConfigResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetConfigs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetConfigs',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetConfigs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.SetConfigRequest,
 *   !proto.social.account.ConfigResponse>}
 */
const methodDescriptor_AccountService_AdminSetConfig = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminSetConfig',
  grpc.web.MethodType.UNARY,
  proto.social.account.SetConfigRequest,
  proto.social.account.ConfigResponse,
  /**
   * @param {!proto.social.account.SetConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ConfigResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.SetConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminSetConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminSetConfig',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminSetConfig,
      callback);
};


/**
 * @param {!proto.social.account.SetConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ConfigResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminSetConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminSetConfig',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminSetConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.FileType,
 *   !proto.social.account.FileType>}
 */
const methodDescriptor_AccountService_AdminUpsertFileType = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminUpsertFileType',
  grpc.web.MethodType.UNARY,
  proto.social.account.FileType,
  proto.social.account.FileType,
  /**
   * @param {!proto.social.account.FileType} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.FileType.deserializeBinary
);


/**
 * @param {!proto.social.account.FileType} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.FileType)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.FileType>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminUpsertFileType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminUpsertFileType',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpsertFileType,
      callback);
};


/**
 * @param {!proto.social.account.FileType} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.FileType>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminUpsertFileType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminUpsertFileType',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminUpsertFileType);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.account.FileTypeListResponse>}
 */
const methodDescriptor_AccountService_AdminGetFileTypes = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetFileTypes',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  proto.social.account.FileTypeListResponse,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.FileTypeListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.FileTypeListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.FileTypeListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetFileTypes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetFileTypes',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetFileTypes,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.FileTypeListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetFileTypes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetFileTypes',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetFileTypes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.FileType,
 *   !proto.social.account.FileType>}
 */
const methodDescriptor_AccountService_AdminDeleteFileType = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminDeleteFileType',
  grpc.web.MethodType.UNARY,
  proto.social.account.FileType,
  proto.social.account.FileType,
  /**
   * @param {!proto.social.account.FileType} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.FileType.deserializeBinary
);


/**
 * @param {!proto.social.account.FileType} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.FileType)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.FileType>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminDeleteFileType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteFileType',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteFileType,
      callback);
};


/**
 * @param {!proto.social.account.FileType} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.FileType>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminDeleteFileType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteFileType',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteFileType);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.IpAddressGetAllRequest,
 *   !proto.social.account.IpAddressListResponse>}
 */
const methodDescriptor_AccountService_AdminGetBlackIpList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminGetBlackIpList',
  grpc.web.MethodType.UNARY,
  proto.social.account.IpAddressGetAllRequest,
  proto.social.account.IpAddressListResponse,
  /**
   * @param {!proto.social.account.IpAddressGetAllRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.IpAddressListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.IpAddressGetAllRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.IpAddressListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.IpAddressListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminGetBlackIpList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminGetBlackIpList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetBlackIpList,
      callback);
};


/**
 * @param {!proto.social.account.IpAddressGetAllRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.IpAddressListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminGetBlackIpList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminGetBlackIpList',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminGetBlackIpList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.IpAddressRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminAddBlackIp = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminAddBlackIp',
  grpc.web.MethodType.UNARY,
  proto.social.account.IpAddressRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.IpAddressRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.IpAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminAddBlackIp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminAddBlackIp',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAddBlackIp,
      callback);
};


/**
 * @param {!proto.social.account.IpAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminAddBlackIp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminAddBlackIp',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminAddBlackIp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.IpAddressRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_AdminDeleteBlackIp = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminDeleteBlackIp',
  grpc.web.MethodType.UNARY,
  proto.social.account.IpAddressRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.IpAddressRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.IpAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminDeleteBlackIp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteBlackIp',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteBlackIp,
      callback);
};


/**
 * @param {!proto.social.account.IpAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminDeleteBlackIp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminDeleteBlackIp',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminDeleteBlackIp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.IpAddressRequest,
 *   !proto.social.account.IpAddressRequest>}
 */
const methodDescriptor_AccountService_AdminFindBlackIp = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminFindBlackIp',
  grpc.web.MethodType.UNARY,
  proto.social.account.IpAddressRequest,
  proto.social.account.IpAddressRequest,
  /**
   * @param {!proto.social.account.IpAddressRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.IpAddressRequest.deserializeBinary
);


/**
 * @param {!proto.social.account.IpAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.IpAddressRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.IpAddressRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminFindBlackIp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminFindBlackIp',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminFindBlackIp,
      callback);
};


/**
 * @param {!proto.social.account.IpAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.IpAddressRequest>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminFindBlackIp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminFindBlackIp',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminFindBlackIp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.account.ActiveListResponse>}
 */
const methodDescriptor_AccountService_ActiveFeatureList = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/ActiveFeatureList',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  proto.social.account.ActiveListResponse,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ActiveListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ActiveListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ActiveListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.activeFeatureList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/ActiveFeatureList',
      request,
      metadata || {},
      methodDescriptor_AccountService_ActiveFeatureList,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ActiveListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.activeFeatureList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/ActiveFeatureList',
      request,
      metadata || {},
      methodDescriptor_AccountService_ActiveFeatureList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.account.ChatCredentialsResponse>}
 */
const methodDescriptor_AccountService_RootGetChatCredentials = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RootGetChatCredentials',
  grpc.web.MethodType.UNARY,
  proto.social.account.Account,
  proto.social.account.ChatCredentialsResponse,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.ChatCredentialsResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.ChatCredentialsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.ChatCredentialsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.rootGetChatCredentials =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RootGetChatCredentials',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootGetChatCredentials,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.ChatCredentialsResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.rootGetChatCredentials =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RootGetChatCredentials',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootGetChatCredentials);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.account.LicenseStatusResponse>}
 */
const methodDescriptor_AccountService_GetLicenseStatus = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/GetLicenseStatus',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  proto.social.account.LicenseStatusResponse,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.LicenseStatusResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.LicenseStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.LicenseStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.getLicenseStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/GetLicenseStatus',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetLicenseStatus,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.LicenseStatusResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.getLicenseStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/GetLicenseStatus',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetLicenseStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.SetRateLimitRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_RootSetRateLimit = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RootSetRateLimit',
  grpc.web.MethodType.UNARY,
  proto.social.account.SetRateLimitRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.SetRateLimitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.SetRateLimitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.rootSetRateLimit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RootSetRateLimit',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootSetRateLimit,
      callback);
};


/**
 * @param {!proto.social.account.SetRateLimitRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.rootSetRateLimit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RootSetRateLimit',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootSetRateLimit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.GetBannedUsersRequest,
 *   !proto.social.account.BannedUserListResponse>}
 */
const methodDescriptor_AccountService_RootGetBannedUsers = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RootGetBannedUsers',
  grpc.web.MethodType.UNARY,
  proto.social.account.GetBannedUsersRequest,
  proto.social.account.BannedUserListResponse,
  /**
   * @param {!proto.social.account.GetBannedUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.BannedUserListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.GetBannedUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.BannedUserListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.BannedUserListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.rootGetBannedUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RootGetBannedUsers',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootGetBannedUsers,
      callback);
};


/**
 * @param {!proto.social.account.GetBannedUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.BannedUserListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.rootGetBannedUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RootGetBannedUsers',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootGetBannedUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.UnbanRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_RootUnbanUser = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RootUnbanUser',
  grpc.web.MethodType.UNARY,
  proto.social.account.UnbanRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.UnbanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.UnbanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.rootUnbanUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RootUnbanUser',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootUnbanUser,
      callback);
};


/**
 * @param {!proto.social.account.UnbanRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.rootUnbanUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RootUnbanUser',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootUnbanUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.GetLimitedUsersRequest,
 *   !proto.social.account.LimitedUserListResponse>}
 */
const methodDescriptor_AccountService_RootGetLimitedUsers = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RootGetLimitedUsers',
  grpc.web.MethodType.UNARY,
  proto.social.account.GetLimitedUsersRequest,
  proto.social.account.LimitedUserListResponse,
  /**
   * @param {!proto.social.account.GetLimitedUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.LimitedUserListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.GetLimitedUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.LimitedUserListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.LimitedUserListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.rootGetLimitedUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RootGetLimitedUsers',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootGetLimitedUsers,
      callback);
};


/**
 * @param {!proto.social.account.GetLimitedUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.LimitedUserListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.rootGetLimitedUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RootGetLimitedUsers',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootGetLimitedUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.GetMethodLimitsRequest,
 *   !proto.social.account.MethodRateLimitListResponse>}
 */
const methodDescriptor_AccountService_RootGetMethodLimits = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RootGetMethodLimits',
  grpc.web.MethodType.UNARY,
  proto.social.account.GetMethodLimitsRequest,
  proto.social.account.MethodRateLimitListResponse,
  /**
   * @param {!proto.social.account.GetMethodLimitsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.MethodRateLimitListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.GetMethodLimitsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.MethodRateLimitListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.MethodRateLimitListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.rootGetMethodLimits =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RootGetMethodLimits',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootGetMethodLimits,
      callback);
};


/**
 * @param {!proto.social.account.GetMethodLimitsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.MethodRateLimitListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.rootGetMethodLimits =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RootGetMethodLimits',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootGetMethodLimits);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.MethodRateLimitListRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_RootBatchSetRateLimits = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/RootBatchSetRateLimits',
  grpc.web.MethodType.UNARY,
  proto.social.account.MethodRateLimitListRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.MethodRateLimitListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.MethodRateLimitListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.rootBatchSetRateLimits =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/RootBatchSetRateLimits',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootBatchSetRateLimits,
      callback);
};


/**
 * @param {!proto.social.account.MethodRateLimitListRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.rootBatchSetRateLimits =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/RootBatchSetRateLimits',
      request,
      metadata || {},
      methodDescriptor_AccountService_RootBatchSetRateLimits);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.DevNotificationOptions,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AccountService_DevSendNotification = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/DevSendNotification',
  grpc.web.MethodType.UNARY,
  proto.social.account.DevNotificationOptions,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.account.DevNotificationOptions} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.account.DevNotificationOptions} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.devSendNotification =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/DevSendNotification',
      request,
      metadata || {},
      methodDescriptor_AccountService_DevSendNotification,
      callback);
};


/**
 * @param {!proto.social.account.DevNotificationOptions} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.devSendNotification =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/DevSendNotification',
      request,
      metadata || {},
      methodDescriptor_AccountService_DevSendNotification);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.DevGetSessionsRequest,
 *   !proto.social.account.SessionListResponse>}
 */
const methodDescriptor_AccountService_DevGetSessions = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/DevGetSessions',
  grpc.web.MethodType.UNARY,
  proto.social.account.DevGetSessionsRequest,
  proto.social.account.SessionListResponse,
  /**
   * @param {!proto.social.account.DevGetSessionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.SessionListResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.DevGetSessionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.SessionListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.SessionListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.devGetSessions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/DevGetSessions',
      request,
      metadata || {},
      methodDescriptor_AccountService_DevGetSessions,
      callback);
};


/**
 * @param {!proto.social.account.DevGetSessionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.SessionListResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.devGetSessions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/DevGetSessions',
      request,
      metadata || {},
      methodDescriptor_AccountService_DevGetSessions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AdminLogsGetRequest,
 *   !proto.social.account.AdminLogsGetResponse>}
 */
const methodDescriptor_AccountService_AdminLogsGet = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/AdminLogsGet',
  grpc.web.MethodType.UNARY,
  proto.social.account.AdminLogsGetRequest,
  proto.social.account.AdminLogsGetResponse,
  /**
   * @param {!proto.social.account.AdminLogsGetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AdminLogsGetResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.AdminLogsGetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AdminLogsGetResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AdminLogsGetResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.adminLogsGet =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/AdminLogsGet',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminLogsGet,
      callback);
};


/**
 * @param {!proto.social.account.AdminLogsGetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AdminLogsGetResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.adminLogsGet =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/AdminLogsGet',
      request,
      metadata || {},
      methodDescriptor_AccountService_AdminLogsGet);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.AiRequest,
 *   !proto.social.account.AiResponse>}
 */
const methodDescriptor_AccountService_Ai = new grpc.web.MethodDescriptor(
  '/social.account.AccountService/Ai',
  grpc.web.MethodType.UNARY,
  proto.social.account.AiRequest,
  proto.social.account.AiResponse,
  /**
   * @param {!proto.social.account.AiRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.account.AiResponse.deserializeBinary
);


/**
 * @param {!proto.social.account.AiRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.account.AiResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.account.AiResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.account.AccountServiceClient.prototype.ai =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.account.AccountService/Ai',
      request,
      metadata || {},
      methodDescriptor_AccountService_Ai,
      callback);
};


/**
 * @param {!proto.social.account.AiRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.account.AiResponse>}
 *     Promise that resolves to the response
 */
proto.social.account.AccountServicePromiseClient.prototype.ai =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.account.AccountService/Ai',
      request,
      metadata || {},
      methodDescriptor_AccountService_Ai);
};


module.exports = proto.social.account;

